/**
 * GENERATED FILE — Polish stem lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-polish.ts from UniMorph pol
 * (https://github.com/unimorph/pol). Data licence: CC BY-SA — see
 * LICENSE-DATA.md.
 *
 * Each line is a lemma and the choices its paradigm makes, one letter per
 * choice:
 *
 *   c  declension class (m masculine, f -a feminine, n neuter, k
 *      consonant-final feminine) when the ending does not give it away
 *   s  the oblique stem, when the rules cannot derive it
 *   g  genitive singular ending      d  dative singular ending
 *   l  locative singular ending      n  nominative plural ending
 *   p  genitive plural ending
 *   A  animate: the accusative singular copies the genitive
 *   P  personal: the accusative plural copies the genitive too
 *   *case.number=form  a cell nothing shorter explains
 */
import type { PlClass, PlStemFlags } from "./declension.js";

const STEM_DATA = `abiturient|ga,A,P,*nominative.pl=abiturienci,*vocative.pl=abiturienci
abnegat|ga,A,P,*nominative.pl=abnegaci,*vocative.pl=abnegaci
abonent|ga,A,P,*nominative.pl=abonenci,*vocative.pl=abonenci
absolwent|ga,A,P,*nominative.pl=absolwenci,*vocative.pl=absolwenci
abstynent|ga,A,P,*nominative.pl=abstynenci,*vocative.pl=abstynenci
adapter|ga
adept|ga,A,P,*nominative.pl=adepci,*vocative.pl=adepci
adiutant|ga,A,P,*nominative.pl=adiutanci,*vocative.pl=adiutanci
administrator|ga,A,P
adresat|ga,A,P,*nominative.pl=adresaci,*vocative.pl=adresaci
adwersarz|ga,A,P,*nominative.pl=adwersarze,*vocative.pl=adwersarze
afgańczyk|ga,A,P
afrodyzjak|ga
agnostyk|ga,A,P
agresor|ga,A,P
akademia|*genitive.sg=akademii,*dative.sg=akademii,*locative.sg=akademii
akcjonariusz|ga,A,P,*nominative.pl=akcjonariusze,*vocative.pl=akcjonariusze
akordeonista|pów,P,*nominative.pl=akordeoniści,*accusative.pl=akordeonistów,*vocative.pl=akordeoniści
akrobata|pów,P,*nominative.pl=akrobaci,*accusative.pl=akrobatów,*vocative.pl=akrobaci
aktor|ga,A,P
aktuariusz|ga,A,P,*nominative.pl=aktuariusze,*vocative.pl=aktuariusze
aktywista|pów,P,*nominative.pl=aktywiści,*accusative.pl=aktywistów,*vocative.pl=aktywiści
akumulator|ga
alabaster|salabastr
albańczyk|ga,A,P
albatros|ga,A
alegoria|*genitive.sg=alegorii,*dative.sg=alegorii,*locative.sg=alegorii
aleja|p,*genitive.sg=alei,*dative.sg=alei,*locative.sg=alei
alergia|*genitive.sg=alergii,*dative.sg=alergii,*locative.sg=alergii
alergolog|ga,A,P
alfons|ga,ni,A,P
aligator|ga,A
alkoholik|ga,A,P
altruista|pów,P,*nominative.pl=altruiści,*accusative.pl=altruistów,*vocative.pl=altruiści
ambasador|ga,A,P
amerykanin|ga,pów,A,P
amnestia|*genitive.sg=amnestii,*dative.sg=amnestii,*locative.sg=amnestii
amortyzator|ga
amper|ga
amperomierz|ga
analfabeta|pów,P,*nominative.pl=analfabeci,*accusative.pl=analfabetów,*vocative.pl=analfabeci
analogia|*genitive.sg=analogii,*dative.sg=analogii,*locative.sg=analogii
anarchista|pów,P,*nominative.pl=anarchiści,*accusative.pl=anarchistów,*vocative.pl=anarchiści
andorczyk|ga,A,P
android|ga,A
anglik|ga,A,P
anglista|pów,P,*nominative.pl=angliści,*accusative.pl=anglistów,*vocative.pl=angliści
angol|ga,A,P,*nominative.pl=Angole,*vocative.pl=Angole
animista|pów,P,*nominative.pl=animiści,*accusative.pl=animistów,*vocative.pl=animiści
anioł|ga,A,*locative.sg=aniele,*vocative.sg=aniele
aniołek|ga,A,P,*nominative.pl=aniołki,*vocative.pl=aniołki
antologia|*genitive.sg=antologii,*dative.sg=antologii,*locative.sg=antologii
antropolog|ga,A,P
antypapież|ga,A,P,*nominative.pl=antypapieże,*vocative.pl=antypapieże
antyszczepionkowiec|ga,ny,pów,A,P,*vocative.sg=antyszczepionkowcze
antywirus|ga,A
apostoł|ga,nowie,A,P
aptekarz|ga,A,P,*nominative.pl=aptekarze,*vocative.pl=aptekarze
ar|ga
arab|ga,nowie,A,P
arabus|ga,A,P,*nominative.pl=arabusy,*vocative.pl=arabusy
arbuz|ga
archanioł|ga,A,*locative.sg=archaniele,*vocative.sg=archaniele
archeolog|ga,A,P
archipelag|*instrumental.sg=archipelagem
architekt|ga,A,P,*nominative.pl=architekci,*vocative.pl=architekci
arcybiskup|ga,ni,A,P
aria|*genitive.sg=arii,*dative.sg=arii,*locative.sg=arii
arkusz|ga
armeńczyk|ga,A,P
armia|*genitive.sg=armii,*dative.sg=armii,*locative.sg=armii
aronia|*genitive.sg=aronii,*genitive.pl=aronii,*dative.sg=aronii,*locative.sg=aronii
artysta|pów,P,*nominative.pl=artyści,*accusative.pl=artystów,*vocative.pl=artyści
arystokrata|pów,P,*nominative.pl=arystokraci,*accusative.pl=arystokratów,*vocative.pl=arystokraci
asembler|ga
astrofizyk|ga,A,P
astrolog|ga,A,P
astronauta|pów,P,*nominative.pl=astronauci,*accusative.pl=astronautów,*vocative.pl=astronauci
astronom|ga,nowie,A,P
ateista|pów,P,*nominative.pl=ateiści,*accusative.pl=ateistów,*vocative.pl=ateiści
ateusz|ga,A,P,*nominative.pl=ateusze,*vocative.pl=ateusze
aula|p
aureola|p
austriak|ga,A,P
autobiografia|*genitive.sg=autobiografii,*dative.sg=autobiografii,*locative.sg=autobiografii
autor|ga,A,P
awanturnik|ga,A,P
awaria|*genitive.sg=awarii,*dative.sg=awarii,*locative.sg=awarii
babcia|*genitive.pl=babć,*vocative.sg=babciu
babunia|*vocative.sg=babuniu
bachor|ga,A
badanie|*genitive.pl=badań
badyl|ga
bagażnik|ga
bagnica|p
bajgiel|sbajgl,ga
bajt|ga
baks|ga,A
bakteria|*genitive.sg=bakterii,*dative.sg=bakterii,*locative.sg=bakterii
bal|pów
bałt|ga,nowie,A,P
banan|ga
bandaż|ga
bandyta|pów,P,*nominative.pl=bandyci,*accusative.pl=bandytów,*vocative.pl=bandyci
bandzior|ga,A,P,*nominative.pl=bandziory,*vocative.pl=bandziory
bania|*genitive.sg=banii,*dative.sg=banii,*locative.sg=banii
banita|pów,P,*nominative.pl=banici,*accusative.pl=banitów,*vocative.pl=banici
barachło|*genitive.pl=baracheł
baran|ga,A
baranek|ga,A
barbarzyńca|ny,pów,P,*accusative.pl=barbarzyńców
barć|ck,ni,P
barman|ga,ni,A,P
barszcz|pów
barwa|p
barwinek|ga
basior|ga,A
basista|pów,P,*nominative.pl=basiści,*accusative.pl=basistów,*vocative.pl=basiści
bask|ga,nowie,A,P
baśń|ck
bat|ga
batat|ga,A
bateria|*genitive.sg=baterii,*dative.sg=baterii,*locative.sg=baterii
batonik|ga
bawełna|p
bawół|*accusative.sg=bawoła
bazylia|*genitive.sg=bazylii,*genitive.pl=bazylii,*dative.sg=bazylii,*locative.sg=bazylii
bażant|ga,A
bąbelek|ga
bąk|sbąk,ga,A
bednarz|ga,A,P,*nominative.pl=bednarze
begonia|*genitive.sg=begonii,*genitive.pl=begonii,*dative.sg=begonii,*locative.sg=begonii
bekerel|ga
belg|ga,nowie,A,P
bemol|ga
bestia|*genitive.sg=bestii,*dative.sg=bestii,*locative.sg=bestii
bezokolicznik|ga
bezpiecznik|ga
bęben|sbębn,ga
bękart|ga,A
białogłowa|*genitive.pl=białogłów
białorusin|ga,ni,A,P
bibliografia|*genitive.sg=bibliografii,*dative.sg=bibliografii,*locative.sg=bibliografii
bibliotekarz|ga,A,P,*nominative.pl=bibliotekarze,*vocative.pl=bibliotekarze
biceps|ga
bicie|*genitive.pl=bić
bicz|ga
biegun|ga
bielik|ga,A
bieluń|ck
biernik|ga
bierzmowanie|*genitive.pl=bierzmowań
bies|ga,A
bila|p
bimber|*genitive.sg=bimbru,*dative.sg=bimbrowi,*instrumental.sg=bimbrem,*locative.sg=bimbrze,*vocative.sg=bimbrze
biodro|*genitive.pl=bioder
biograf|ga,nowie,A,P
biografia|*genitive.sg=biografii,*dative.sg=biografii,*locative.sg=biografii
biolog|ga,A,P
biskup|ga,ni,A,P
biurowiec|ga,pów
biustonosz|ga
biznesmen|ga,ni,A,P
bizon|ga,A
blacha|ny,*genitive.sg=blachy
blacharz|ga,A,P,*nominative.pl=blacharze,*vocative.pl=blacharze
blachosmród|ga,A
blazonowanie|*genitive.pl=blazonowań
blizna|p
bliźni|cn,ni,A,P,*genitive.sg=bliźniego,*genitive.pl=bliźnich,*dative.sg=bliźniemu,*dative.pl=bliźnim,*accusative.sg=bliźniego,*accusative.pl=bliźnich,*instrumental.sg=bliźnim,*instrumental.pl=bliźnimi,*locative.sg=bliźnim,*locative.pl=bliźnich
bliźnię|sbliźnięt,*genitive.sg=bliźnięcia,*genitive.pl=bliźniąt,*dative.sg=bliźnięciu,*instrumental.sg=bliźnięciem,*locative.sg=bliźnięciu
bloger|ga,A,P
blondyn|ga,ni,A,P
błonie|*genitive.pl=błoń
błotniak|ga,A
błotnik|ga
błyskawica|p
bobas|ga,A
bobslej|ga,pów
bochen|sbochn,ga
bocian|ga,A
boczki|cn,*genitive.sg=boczków,*dative.sg=boczkom,*instrumental.sg=boczkami,*locative.sg=boczkach
bod|*vocative.sg=bodzieb
bodziec|sbodźc,ga,pów
bogactwo|p
bogacz|ga,A,P,*nominative.pl=bogacze,*vocative.pl=bogacze
bogini|cf,sbogini,*genitive.pl=bogiń,*vocative.sg=bogini
bohater|ga,A,P
boja|*genitive.sg=boi,*genitive.pl=boi,*dative.sg=boi,*locative.sg=boi
bojaźń|ck
bokobrody|cn,*genitive.sg=bokobrodów,*dative.sg=bokobrodom,*instrumental.sg=bokobrodami,*locative.sg=bokobrodach
bolec|ga,pów
borowik|ga
borsuk|ga,A
boskość|ck,ni,P
bosman|ga,ni,A,P
botanik|ga,A,P
bożyszcze|py
bóbr|ga,A
bój|pów
ból|sból,pów
bóstwo|p
bramkarz|ga,A,P,*nominative.pl=bramkarze,*vocative.pl=bramkarze
branża|p
brat|sbraci,le,na,pi,A,P,*genitive.sg=brata,*dative.sg=bratu,*accusative.sg=brata,*instrumental.sg=bratem,*instrumental.pl=braćmi
bratanek|ga,nowie,A,P
bratanica|p
bratek|ga,A
bratowa|ne,*genitive.sg=bratowej,*genitive.pl=bratowych,*dative.sg=bratowej,*dative.pl=bratowym,*accusative.sg=bratową,*instrumental.pl=bratowymi,*locative.sg=bratowej,*locative.pl=bratowych
brawura|*accusative.sg=brawurą,*instrumental.sg=brawurę
brew|sbrwi,gi,di,li,ni,pi,P,*accusative.sg=brew,*instrumental.sg=brwią
brewiarz|ga
broda|*genitive.pl=bród
brodacz|ga,A,P,*nominative.pl=brodacze,*vocative.pl=brodacze
brodawnik|ga
brojler|ga,A
broń|ck
brosma|*dative.sg=brośmie,*locative.sg=brośmie
brosza|p
browiec|ga,pów,A
brudas|ga,ni,A,P
brukiew|sbrukwi,gi,di,li,pi,*instrumental.sg=brukwią
brukowiec|ga,pów
brus|ga
brytyjczyk|ga,A,P
brzemię|sbrzemion,*genitive.sg=brzemienia,*dative.sg=brzemieniu,*instrumental.sg=brzemieniem,*locative.sg=brzemieniu
brzoskwinia|*genitive.pl=brzoskwiń
brzoza|*genitive.pl=brzóz
brzuch|ga,ny,*instrumental.sg=brzuchem
brzuszek|ga,*nominative.sg=bruszek,*accusative.sg=bruszek
brzydal|ga,A,P,*nominative.pl=brzydale,*vocative.pl=brzydale
brzytwa|p
buc|ga,pów,A
buddysta|pów,P,*nominative.pl=buddyści,*accusative.pl=buddystów,*vocative.pl=buddyści
budowa|*genitive.pl=budów
budowniczy|cn,ny,A,P,*genitive.sg=budowniczego,*genitive.pl=budowniczych,*dative.sg=budowniczemu,*dative.pl=budowniczym,*accusative.sg=budowniczego,*accusative.pl=budowniczych,*instrumental.sg=budowniczym,*instrumental.pl=budowniczymi,*locative.sg=budowniczym,*locative.pl=budowniczych
budzik|ga
budziszynianin|ga,A,*accusative.pl=budziszynianów
bufon|ga,ni,A,P
bukłak|ga
buldog|ga,A
bulwa|p
buławnik|ga
bułgar|ga,A,P
buntownik|ga,A,P
burmistrz|ga,nowie,pów,A,P
burnus|ga
burza|p
burżuj|ga,pów,A,P,*nominative.pl=burżuje,*vocative.pl=burżuje
bus|ga,A
but|ga
buzia|P,*accusative.pl=buzi,*vocative.sg=buzi
buziak|ga,A
byk|ga,A
bykowe|*genitive.sg=bykowego,*dative.sg=bykowemu,*instrumental.sg=bykowym,*locative.sg=bykowym
była|ne,*genitive.sg=byłej,*genitive.pl=byłych,*dative.sg=byłej,*dative.pl=byłym,*accusative.sg=byłą,*instrumental.pl=byłymi,*locative.sg=byłej,*locative.pl=byłych,*vocative.sg=była
bywalec|ga,ny,pów,A,P
cadyk|ga,nowie,A,P
cal|ga
całkowanie|*genitive.pl=całkowań
całopalenie|*genitive.pl=całopaleń
car|ga,nowie,A,P
caryca|p
ceber|scebr,ga
cebrzyk|ga
cebula|p
cebulica|p
cech|ny,*instrumental.sg=cechem
cecha|ny,*genitive.sg=cechy
cedzak|ga
cela|p
celnik|ga,A,P
celownik|ga
celt|ga,nowie,A,P
cennik|ga
cenobita|pów,P,*nominative.pl=cenobici,*accusative.pl=cenobitów,*vocative.pl=cenobici
cent|ga,A
centymetr|ga
cep|ga
ceremonia|*genitive.sg=ceremonii,*genitive.pl=ceremonii,*dative.sg=ceremonii,*locative.sg=ceremonii
cerkiew|scerkwi,gi,di,li,pi,*instrumental.sg=cerkwią
cesarz|ga,A,P,*nominative.pl=cesarze,*vocative.pl=cesarze
cesarzowa|ne,*genitive.sg=cesarzowej,*genitive.pl=cesarzowych,*dative.sg=cesarzowej,*dative.pl=cesarzowym,*accusative.sg=cesarzową,*instrumental.pl=cesarzowymi,*locative.sg=cesarzowej,*locative.pl=cesarzowych
cewnik|ga
cezar|ga,A,P
chałwa|p
cham|ga,A,P,*nominative.pl=chamy,*vocative.pl=chamy
chan|ga,nowie,A,P
chart|ga,A
chasyd|ga,A,P,*nominative.pl=chasydzi,*vocative.pl=chasydzi
chaus|ga,A
chciwość|ck,ni,P
cheeseburger|ga,A
chemik|ga,A,P
chińczyk|ga,A
chińczyk|ga,A,P
chips|ga,A
chirurg|ga,A,P
chleb|ga
chlew|ga
chłody|cn,*genitive.sg=chłodów,*dative.sg=chłodom,*instrumental.sg=chłodami,*locative.sg=chłodach
chłop|ga,du,ni,A,P
chłopak|ga,A,P
chłopczyca|p
chłopczyk|ga,A,P,*nominative.pl=chłoczyki,*vocative.pl=chłoczyki
chłopiec|ga,du,ny,pów,A,P,*vocative.sg=chłopcze
chochla|*genitive.pl=chochel
chochlik|ga,A
chodnik|ga
chomik|ga,A
chorągiew|schorągwi,gi,di,li,pi,*instrumental.sg=chorągwią
choróbsko|p,*instrumental.sg=choróbskem
chorwat|ga,A,P,*nominative.pl=Chorwaci,*vocative.pl=Chorwaci
chór|schór
chrabąszcz|schrabąszcz,ga,A
chronologia|*genitive.sg=chronologii,*dative.sg=chronologii,*locative.sg=chronologii
chruścik|ga,A
chrystadelfianin|ga,A,P
chrzcielnica|p
chrzest|schrzt
chrześcijanin|ga,A,P
chrześniak|ga,A,P
chwila|p
chytrość|ck
ciacho|*instrumental.sg=ciachem
ciało|*locative.sg=ciele
ciapaty|cn,A,P,*nominative.pl=ciapaci,*genitive.sg=ciapatego,*genitive.pl=ciapatych,*dative.sg=ciapatemu,*dative.pl=ciapatym,*accusative.sg=ciapatego,*accusative.pl=ciapatych,*instrumental.sg=ciapatym,*instrumental.pl=ciapatymi,*locative.sg=ciapatym,*locative.pl=ciapatych,*vocative.pl=ciapaci
ciasto|*locative.sg=cieście
ciąg|sciąg
ciągłość|ck
ciągnik|ga
ciąża|p
ciecz|ck
cieć|ga,A,P,*nominative.pl=ciecie,*vocative.pl=ciecie
cielę|scielęt,*genitive.sg=cielęcia,*genitive.pl=cieląt,*dative.sg=cielęciu,*instrumental.sg=cielęciem,*locative.sg=cielęciu
ciemiernik|ga
ciemię|sciemion,*genitive.sg=ciemienia,*dative.sg=ciemieniu,*instrumental.sg=ciemieniem,*locative.sg=ciemieniu
ciemność|ck,ni,P
cień|ga
cieplik|ga
cierń|ga
cieśla|P,*accusative.pl=cieśli
cietrzew|scietrzewi,ga,pi,A
cinkciarz|ga,A,P,*nominative.pl=cinkciarze,*vocative.pl=cinkciarze
ciocia|*genitive.pl=cioć,*vocative.sg=ciociu
cis|ga
ciśnienie|*genitive.pl=ciśnień
ciuch|ga,ny,*instrumental.sg=ciuchem
ciuchcia|*genitive.pl=ciuchć
ciufcia|*genitive.pl=ciufć
cmentarz|ga
cnota|*genitive.pl=cnót
cokół|ga
coleslaw|ga
colesław|ga
cosinus|ga
cotangens|ga
cudo|pów
cudzoziemiec|ga,ny,pów,A,P,*vocative.sg=cudzoziemcze
cugiel|scugl,ga
cukier|scukr
cukiereczek|ga
cukierek|ga
cukiernik|ga,A,P
cukinia|*genitive.sg=cukinii,*genitive.pl=cukinii,*dative.sg=cukinii,*locative.sg=cukinii
cukrzyca|p
cyberprzestrzeń|ck
cyborg|ga,A
cyc|ga,pów
cycek|ga
cycuszek|ga,A
cynik|ga,A,P
cynober|*genitive.sg=cynobru,*dative.sg=cynobrowi,*instrumental.sg=cynobrem,*locative.sg=cynobrze,*vocative.sg=cynobrze
cyrkiel|scyrkl,ga
cyrylica|p
cysterna|p
cytadela|p
czajnik|ga
czaprak|ga
czardasz|ga,A
czarnuch|ga,ny,A,P,*instrumental.sg=czarnuchem
czarodziej|ga,A,P,*nominative.pl=czarodzieje,*genitive.pl=czarodziei,*accusative.pl=czarodziei,*vocative.pl=czarodzieje
czarownica|p
czarownik|ga,A,P
czasomierz|ga
czasopismo|*locative.sg=czasopiśmie
czasoprzestrzeń|ck
czasownik|ga
czasza|p
cząber|scząbr
czech|ga,A,P,*nominative.pl=Czesi,*instrumental.sg=Czechem,*vocative.pl=Czesi
czek|ga
czekan|ga
czeladnik|ga,A,P
czeluść|ck
czepek|ga
czeremcha|ny,*genitive.sg=czeremchy
czerep|ga
czerniak|ga,A
czernica|p
czerpak|ga
czerw|sczerwi,ga,pi,A
czerwiec|ga,pów
czerwień|ck
częstotliwość|ck,ni,P
część|ck,ni,P
czips|ga,A
czirokez|ga,ni,A,P
człowieczeństwo|p
człowiek|ga,A,P,*nominative.pl=ludzie,*genitive.pl=ludzi,*dative.pl=ludziom,*accusative.pl=ludzi,*instrumental.pl=ludźmi,*locative.pl=ludziach,*vocative.sg=człowiecze,*vocative.pl=ludzie
czopek|ga
czort|ga,A,P,*nominative.pl=czorty,*vocative.pl=czorty
czosnaczek|ga
czuwasz|ga,A,P,*nominative.pl=Czuwasze,*vocative.pl=Czuwasze
czworokąt|sczworokąt,ga
czynel|ga
czynnik|ga
czynność|ck,ni,P
czysta|ne,*genitive.sg=czystej,*genitive.pl=czystych,*dative.sg=czystej,*dative.pl=czystym,*accusative.sg=czystą,*instrumental.pl=czystymi,*locative.sg=czystej,*locative.pl=czystych,*vocative.sg=czysta
czytanie|*genitive.pl=czytań
czytelnik|ga,A,*nominative.pl=czytelnicy,*accusative.pl=czytelnicy,*vocative.pl=czytelnicy
czytelność|ck
ćma|*genitive.pl=ciem
ćwiczenie|*genitive.pl=ćwiczeń
ćwiek|ga
ćwierć|ck,ni,P
dach|ny,*instrumental.sg=dachem
dachowiec|ga,pów,A
daktyl|ga
daktylowiec|ga,pów,*dative.sg=daktylowowi,*dative.pl=daktylowom
dal|ck
dalia|*genitive.sg=dalii,*genitive.pl=dalii,*dative.sg=dalii,*locative.sg=dalii
dalmatyńczyk|ga,A
dandys|ga,ni,A,P
daniel|ga,A
darń|ck
darowizna|p
darwinista|pów,P,*nominative.pl=darwiniści,*accusative.pl=darwinistów,*vocative.pl=darwiniści
daszek|ga
dawca|ny,pów,P,*accusative.pl=dawców
dawczyni|cf,sdawczyni,*genitive.pl=dawczyń,*vocative.sg=dawczyni
debeściak|ga,A,P,*nominative.pl=debeściaki,*vocative.pl=debeściaki
debil|ga,A,P,*nominative.pl=debile,*vocative.pl=debile
decha|ny,*genitive.sg=dechy
decymetr|ga
deista|pów,P,*nominative.pl=deiści,*accusative.pl=deistów,*vocative.pl=deiści
dekarz|ga,A,P,*nominative.pl=dekarze,*vocative.pl=dekarze
dekiel|sdekl,ga
dekielek|ga
delegat|ga,A,P,*nominative.pl=delegaci,*vocative.pl=delegaci
delikwent|ga,A,P,*nominative.pl=delikwenci,*vocative.pl=delikwenci
demagog|ga,nowie,A,P
demograf|ga,nowie,A,P
demokrata|pów,P,*nominative.pl=demokraci,*accusative.pl=demokratów,*vocative.pl=demokraci
demon|ga,A
demonstrant|ga,A,P,*nominative.pl=demonstranci,*vocative.pl=demonstranci
dentysta|pów,P,*nominative.pl=dentyści,*accusative.pl=dentystów,*vocative.pl=dentyści
depesza|p
depilator|ga
dereń|ga
dermatolog|ga,A,P
deseń|ga
deskarz|ga,A,P,*nominative.pl=deskarze,*vocative.pl=deskarze
despota|pów,P,*nominative.pl=despoci,*accusative.pl=despotów,*vocative.pl=despoci
detektyw|ga,ni,A,P
deweloper|ga,A,P
dewota|pów,P,*nominative.pl=dewoci,*accusative.pl=dewotów,*vocative.pl=dewoci
deżdż|sdżdż,ga,pów
diabeł|sdiabł,ga,du,A
diablica|p
dialektologia|*genitive.sg=dialektologii,*dative.sg=dialektologii,*locative.sg=dialektologii
dinar|ga,A
dinozaur|ga,A
dioptria|*genitive.sg=dioptrii,*dative.sg=dioptrii,*locative.sg=dioptrii
dj|sDJ-,ga,lu,ne,A,P
dłoń|ck,*instrumental.pl=dłońmi
długość|ck,ni,P
dłużnik|ga,A,P
doba|*genitive.pl=dób
dobro|lu,*genitive.pl=dóbr
dobrodziej|ga,pów,A,P,*nominative.pl=dobrodzieje,*vocative.pl=dobrodzieje
docent|ga,A,P,*nominative.pl=docenci,*vocative.pl=docenci
dodawanie|*genitive.pl=dodawań
doker|ga,A,P
dokonanie|*genitive.pl=dokonań
doktor|ga,A,P
dola|p
dolar|ga,A
dolec|ga,pów,A
dom|lu
domator|ga,A,P
domknięcie|*genitive.pl=domknięć
donica|p
dopalacz|ga
dopełniacz|ga
dopełnienie|*genitive.pl=dopełnień
doradca|ny,pów,P,*accusative.pl=doradców
dorosłość|ck
dorsz|ga,A
dorzecze|py
dostawczak|ga,A
doświadczenie|*genitive.pl=doświadczeń
dozorca|ny,pów,P,*accusative.pl=dozorców
dozorczyni|cf,sdozorczyni,*genitive.pl=dozorczyń,*vocative.sg=dozorczyni
drab|ga,A,P,*nominative.pl=draby,*vocative.pl=draby
drań|ga,A
drapieżnik|ga,A
draże|*genitive.sg=draży,*dative.sg=drażom,*instrumental.sg=drażami,*locative.sg=drażach
drąg|sdrąg,ga
dresiarz|ga,A,P,*nominative.pl=dresiarze,*vocative.pl=dresiarze
drewniak|ga,A
drewno|*genitive.pl=drewien
drganie|*genitive.pl=drgań
droga|*genitive.pl=dróg
dromader|ga,A
drop|sdropi,ga,pi,A,*vocative.sg=dropie
drozd|ga,A
druh|ga,lu,nowie,A,P
drwal|ga,A,P,*nominative.pl=drwale,*vocative.pl=drwale
duch|ga,ny,A,*instrumental.sg=duchem
dudek|ga,A
dudy|cn,*genitive.sg=dud,*dative.sg=dudom,*instrumental.sg=dudami,*locative.sg=dudach
dudziarz|ga,A,P,*nominative.pl=dudziarze,*vocative.pl=dudziarze
duńczyk|ga,A,P
dupek|ga,A
duperele|*genitive.sg=dupereli,*dative.sg=duperelom,*instrumental.sg=duperelami,*locative.sg=duperelach
durszlak|ga
dusza|p
dworzanin|ga,A,P
dworzec|sdworc,ga,pów
dwujęzyczność|ck
dwukropek|ga
dwunastnica|p
dwusieczna|ne,*genitive.sg=dwusiecznej,*genitive.pl=dwusiecznych,*dative.sg=dwusiecznej,*dative.pl=dwusiecznym,*accusative.sg=dwusieczną,*instrumental.pl=dwusiecznymi,*locative.sg=dwusiecznej,*locative.pl=dwusiecznych,*vocative.sg=dwusieczna
dybuk|ga,A
dycha|ny,*genitive.sg=dychy
dykcjonarz|ga
dyktando|*genitive.pl=dyktaned
dyktator|ga,A,P
dymnica|p
dynia|*genitive.pl=dyń
dyplomata|pów,P,*nominative.pl=dyplomaci,*accusative.pl=dyplomatów,*vocative.pl=dyplomaci
dyrektor|ga,A,P
dyrygent|ga,A,P,*nominative.pl=dyrygenci,*vocative.pl=dyrygenci
dysproz|lu
dystans|ne
dysydent|ga,A,P,*nominative.pl=dysydenci,*vocative.pl=dysydenci
dysza|p
dyszel|sdyszl,ga
dziadek|ga,nowie,A,P
działacz|ga,A,P,*nominative.pl=działacze,*vocative.pl=działacze
działanie|*genitive.pl=działań
dzidziuś|ga,A,P,*nominative.pl=dzidziusie,*vocative.pl=dzidziusie
dziecię|sdziecięt,*genitive.sg=dziecięcia,*genitive.pl=dzieciąt,*dative.sg=dziecięciu,*instrumental.sg=dziecięciem,*locative.sg=dziecięciu
dziecko|sdzieci,ni,P,*genitive.sg=dziecka,*dative.sg=dziecku,*instrumental.sg=dzieckiem,*instrumental.pl=dziećmi,*locative.sg=dziecku
dziedzic|ga,pów,A,P,*nominative.pl=dziedzice,*vocative.pl=dziedzice
dziedziniec|sdziedzińc,ga,pów
dzielenie|*genitive.pl=dzieleń
dzielna|ne,*genitive.sg=dzielnej,*genitive.pl=dzielnych,*dative.sg=dzielnej,*dative.pl=dzielnym,*accusative.sg=dzielną,*instrumental.pl=dzielnymi,*locative.sg=dzielnej,*locative.pl=dzielnych,*vocative.sg=dzielna
dzielnica|p
dzielnik|ga
dziennik|ga
dziennikarz|ga,A,P,*nominative.pl=dziennikarze,*vocative.pl=dziennikarze
dzień|sdni,ga,ni,pi,P,*accusative.sg=dzień
dzietność|ck
dziewczę|sdziewczęt,*genitive.sg=dziewczęcia,*genitive.pl=dziewcząt,*dative.sg=dziewczęciu,*instrumental.sg=dziewczęciem,*locative.sg=dziewczęciu
dziewica|p
dziewierz|ga,A,P,*nominative.pl=dziewierze,*vocative.pl=dziewierze
dziewięciornik|ga
dziewoja|*genitive.sg=dziewoi,*genitive.pl=dziewoi,*dative.sg=dziewoi,*locative.sg=dziewoi
dzieża|p
dzięcioł|ga,A
dzik|ga,A
dzikus|ga,A,P,*nominative.pl=dzikusy,*vocative.pl=dzikusy
dziobak|ga,A
dzióbek|sdzióbk,ga
dziurawiec|ga,pów
dzwonek|ga
dzwoniec|sdzwońc,ga,pów,A
dżdżownica|p
dżentelmen|ga,ni,A,P
dżezmen|ga,ni,A,P
dżinn|ga,A,P,*nominative.pl=dżinny,*vocative.pl=dżinny
dżojstik|ga
dżokej|ga,pów,A,P,*nominative.pl=dżokeje,*vocative.pl=dżokeje
dżoker|ga,A
dżudoka|pów,P,*nominative.pl=dżudocy,*accusative.pl=dżudoków,*vocative.pl=dżudocy
dżul|ga
e-mail|ga
echo|*instrumental.sg=echem
edredon|ga,A
edyl|ga,nowie,A,P
egiptolog|ga,A,P
egoista|pów,P,*nominative.pl=egoiści,*accusative.pl=egoistów,*vocative.pl=egoiści
egzorcysta|pów,P,*nominative.pl=egzorcyści,*accusative.pl=egzorcystów,*vocative.pl=egzorcyści
ekolog|ga,A,P
ekonomista|pów,P,*nominative.pl=ekonomiści,*accusative.pl=ekonomistów,*vocative.pl=ekonomiści
ekshibicjonista|pów,P,*nominative.pl=ekshibicjoniści,*accusative.pl=ekshibicjonistów,*vocative.pl=ekshibicjoniści
ekspedient|ga,A,P,*nominative.pl=ekspedienci,*vocative.pl=ekspedienci
ekspert|ga,A,P,*nominative.pl=eksperci,*vocative.pl=eksperci
ekwilibrysta|pów,P,*nominative.pl=ekwilibryści,*accusative.pl=ekwilibrystów,*vocative.pl=ekwilibryści
elektronik|ga,A,P
elektronowolt|ga
elektryk|ga,A,P
emir|ga,nowie,A,P
encyklopedia|*genitive.sg=encyklopedii,*dative.sg=encyklopedii,*locative.sg=encyklopedii
energia|*genitive.sg=energii,*dative.sg=energii,*locative.sg=energii
entalpia|*genitive.sg=entalpii,*dative.sg=entalpii,*locative.sg=entalpii
enter|ga
entomolog|ga,A,P
entropia|*genitive.sg=entropii,*dative.sg=entropii,*locative.sg=entropii
entuzjasta|pów,P,*nominative.pl=entuzjaści,*accusative.pl=entuzjastów,*vocative.pl=entuzjaści
epidemia|*genitive.sg=epidemii,*dative.sg=epidemii,*locative.sg=epidemii
eremita|pów,P,*nominative.pl=eremici,*accusative.pl=eremitów,*vocative.pl=eremici
esej|pów
esemes|ga,A
ester|sestr
esteta|pów,P,*nominative.pl=esteci,*accusative.pl=estetów,*vocative.pl=esteci
etnologia|*genitive.sg=etnologii,*dative.sg=etnologii,*locative.sg=etnologii
etrusk|ga,nowie,A,P
etymologia|*genitive.sg=etymologii,*dative.sg=etymologii,*locative.sg=etymologii
eucharystia|*genitive.sg=eucharystii,*dative.sg=eucharystii,*locative.sg=eucharystii
eurodance|cm,*genitive.sg=eurodance'u,*dative.sg=eurodance'owi,*instrumental.sg=eurodance'em,*locative.sg=eurodansie,*vocative.sg=eurodansie
europejczyk|ga,A,P
eutanazista|pów,P,*nominative.pl=eutanaziści,*accusative.pl=eutanazistów,*vocative.pl=eutanaziści
ewangeliarz|ga
facet|ga,A,P,*nominative.pl=faceci,*vocative.pl=faceci
fag|ga,A
fajek|ga,A
fałsz|pów
fałszerz|ga,A,P,*nominative.pl=fałszerze,*vocative.pl=fałszerze
fanatyk|ga,A,P
farad|ga
faraon|ga,nowie,A,P
farfocel|sfarfocl,ga
farmaceuta|pów,P,*nominative.pl=farmaceuci,*accusative.pl=farmaceutów,*vocative.pl=farmaceuci
farmazon|ga
fartuch|ga,ny,*instrumental.sg=fartuchem
faryzeusz|ga,A,P,*nominative.pl=faryzeusze,*vocative.pl=faryzeusze
faszysta|pów,P,*nominative.pl=faszyści,*accusative.pl=faszystów,*vocative.pl=faszyści
fatalista|pów,P,*nominative.pl=fataliści,*accusative.pl=fatalistów,*vocative.pl=fataliści
fatwa|p
faul|ga
fax|sfaks
fazan|ga,A
fenek|ga,A
fenicjanin|ga,A,P
feniks|ga,A
fetysz|ga
fideista|pów,P,*nominative.pl=fideiści,*accusative.pl=fideistów,*vocative.pl=fideiści
figi|cn,*genitive.sg=fig,*dative.sg=figom,*instrumental.sg=figami,*locative.sg=figach
filc|pów
filmowiec|ga,ny,pów,A,P
filolog|ga,A,P
filologia|*genitive.sg=filologii,*dative.sg=filologii,*locative.sg=filologii
filozof|ga,nowie,A,P
finalista|pów,P,*nominative.pl=finaliści,*accusative.pl=finalistów,*vocative.pl=finaliści
fiołek|ga
fistaszek|ga,A
fitochemia|*genitive.sg=fitochemii,*dative.sg=fitochemii,*locative.sg=fitochemii
fitopatologia|*genitive.sg=fitopatologii,*dative.sg=fitopatologii,*locative.sg=fitopatologii
fiut|ga,A
fizjonomia|*genitive.sg=fizjonomii,*dative.sg=fizjonomii,*locative.sg=fizjonomii
fizjoterapeuta|pów,P,*nominative.pl=fizjoterapeuci,*accusative.pl=fizjoterapeutów,*vocative.pl=fizjoterapeuci
fizyk|ga,A,P
flaming|ga,A
flądra|*genitive.pl=fląder
flecista|pów,P,*nominative.pl=fleciści,*accusative.pl=flecistów,*vocative.pl=fleciści
fobia|*genitive.sg=fobii,*dative.sg=fobii,*locative.sg=fobii
fonetyk|ga,A,P
fonologia|*genitive.sg=fonologii,*dative.sg=fonologii,*locative.sg=fonologii
fontanna|p
forint|ga,A
formalista|pów,P,*nominative.pl=formaliści,*accusative.pl=formalistów,*vocative.pl=formaliści
foryś|ga,pów,A,P,*nominative.pl=forysie,*vocative.pl=forysie
fotel|ga
fotograf|ga,nowie,A,P
fotografia|*genitive.sg=fotografii,*dative.sg=fotografii,*locative.sg=fotografii
frajer|ga,A,P
francuz|ga,ni,A,P
frank|ga,A
frankowicz|ga,A,P,*nominative.pl=frankowicze,*vocative.pl=frankowicze
frezer|ga,A,P
fristajlowiec|ga,ny,pów,A,P,*vocative.sg=fristajlowcze
fryzjer|ga,A,P
ftyzjologia|*genitive.sg=ftyzjologii,*dative.sg=ftyzjologii,*locative.sg=ftyzjologii
fuks|ga
ful|ga
funkcjonariusz|ga,A,P,*nominative.pl=funkcjonariusze,*vocative.pl=funkcjonariusze
funktor|ga
funpag|ga
futro|*genitive.pl=futer
futrzak|ga,A
gad|ga,A
gadożer|ga,A
gaj|pów
gajowy|cn,ni,A,P,*genitive.sg=gajowego,*genitive.pl=gajowych,*dative.sg=gajowemu,*dative.pl=gajowym,*accusative.sg=gajowego,*accusative.pl=gajowych,*instrumental.sg=gajowym,*instrumental.pl=gajowymi,*locative.sg=gajowym,*locative.pl=gajowych
gala|p
galernik|ga,A,P
gałąź|ck
gamepad|ga
gamoń|ga,A,P,*nominative.pl=gamonie,*vocative.pl=gamonie
gap|sgapi,ga,pów,A,P,*nominative.pl=gapie,*vocative.pl=gapie
garb|ga
garbarz|ga,A,P,*nominative.pl=garbarze,*vocative.pl=garbarze
garderoba|*genitive.pl=garderób
gardziel|ck
gargulec|ga,pów
garncarz|ga,A,P,*nominative.pl=garncarze,*vocative.pl=garncarze
garnek|ga
garnuszek|ga
garść|ck
gastarbajter|ga,A,P
gaśnica|p
gawron|ga,A
gazela|p
gaźnik|ga
gąsienica|p
gąsiorek|ga,A
gej|ga,pów,A,P,*nominative.pl=geje,*vocative.pl=geje
gejsza|p
gekon|ga,A
genealogia|*genitive.sg=genealogii,*dative.sg=genealogii,*locative.sg=genealogii
generał|ga,nowie,A,P
geniusz|ga,pów,A,P,*nominative.pl=geniusze,*vocative.pl=geniusze
geodeta|pów,P,*nominative.pl=geodeci,*accusative.pl=geodetów,*vocative.pl=geodeci
geograf|ga,nowie,A,P
geolog|ga,A,P
gepard|ga,A
getry|cn,*genitive.sg=getrów,*dative.sg=getrom,*instrumental.sg=getrami,*locative.sg=getrach
gęstość|ck,ni,P
gęstwa|p
gęś|ck,ni,P,*instrumental.pl=gęśmi
gibon|ga,A
giez|sgz,ga,A
gigantomachia|*genitive.sg=gigantomachii,*dative.sg=gigantomachii,*locative.sg=gigantomachii
gil|ga,A
ginekolog|ga,A,P
gitarzysta|pów,P,*nominative.pl=gitarzyści,*accusative.pl=gitarzystów,*vocative.pl=gitarzyści
gliniarz|ga,A,P,*nominative.pl=gliniarze,*vocative.pl=gliniarze
globus|ga
glut|ga
głosowanie|*genitive.pl=głosowań
głośnik|ga
głośność|ck,ni,P
głowa|*genitive.pl=głów
głowica|p
głupek|ga,A,P,*nominative.pl=głupki,*dative.sg=głupowi,*vocative.pl=głupki
głupiec|ga,ny,pów,A,P,*vocative.sg=głupcze
głuptak|ga,A
głuptas|ga,A,P,*nominative.pl=głuptasy,*vocative.pl=głuptasy
głuszec|ga,pów,A
gmach|ny,*instrumental.sg=gmachem
gnat|ga,A
gniazdo|*locative.sg=gnieździe
gnój|pów
godność|ck,ni,P
gol|ga,A
golfista|pów,P,*nominative.pl=golfiści,*accusative.pl=golfistów,*vocative.pl=golfiści
gołąbek|sgołąbk,ga
gołębię|sgołębięt,*genitive.sg=gołębięcia,*genitive.pl=gołębiąt,*dative.sg=gołębięciu,*instrumental.sg=gołębięciem,*locative.sg=gołębięciu
gołębnik|ga
gołoledź|ck
gorczyca|p
gorzów|ga
gospoda|*genitive.pl=gospód
gospodarz|ga,A,P,*nominative.pl=gospodarze,*vocative.pl=gospodarze
gospodyni|cf,sgospodyni,*genitive.pl=gospodyń,*vocative.sg=gospodyni
gościniec|sgościńc,ga,pów
gościnność|ck
gość|ga,A,P,*nominative.pl=goście,*instrumental.pl=gośćmi,*vocative.pl=goście
goździk|ga,A
górnik|ga,A,P
gówniak|ga,A
gówniarz|ga,A,P,*nominative.pl=gówniarze,*vocative.pl=gówniarze
gówno|*genitive.pl=gówien
gównoburza|p
gra|*genitive.pl=gier
grabarz|ga,A,P,*nominative.pl=grabarze,*vocative.pl=grabarze
gracz|ga,A,P,*nominative.pl=gracze,*vocative.pl=gracze
graham|ga
gram|ga
granatowiec|ga,pów
graniastosłup|ga
granica|p
grań|ck
grat|ga,A
grawerowanie|*genitive.pl=grawerowań
grążel|ga
grej|ga,pów
grejpfrut|ga,A
grek|sGrek,ga,A,P
grill|ga
grindwal|ga,A,P,*nominative.pl=grindwale,*vocative.pl=grindwale
gronostaj|ga,pów,A
grosz|ga
groza|*genitive.pl=gróz
groźba|*genitive.pl=gróźb
grucha|ny,*genitive.sg=gruchy
gruchot|ga,A
grudzień|sgrudni,ga,pi
grusza|p
gruzin|ga,ni,A,P
gryzoń|ga,A
grzebień|ga
grzech|ny,*instrumental.sg=grzechem
grzechotnik|ga,A
grzeczność|ck,ni,P
grzesiek|sGrześk,ga,A,P,*nominative.pl=Grześki,*vocative.pl=Grześki
grzesznik|ga,A,P
grześ|ga,A,P,*nominative.pl=Grzesie,*vocative.pl=Grzesie
grzyb|ga
grzybek|ga
grzybienie|*genitive.sg=grzybieni,*dative.sg=grzybieniom,*instrumental.sg=grzybieniami,*locative.sg=grzybieniach
grzybień|ga
grzybobranie|*genitive.pl=grzybobrań
grzybowa|ne,*genitive.sg=grzybowej,*genitive.pl=grzybowych,*dative.sg=grzybowej,*dative.pl=grzybowym,*accusative.sg=grzybową,*instrumental.pl=grzybowymi,*locative.sg=grzybowej,*locative.pl=grzybowych,*vocative.sg=grzybowa
grzywna|*genitive.pl=grzywien
guziczek|ga
guziec|sguźc,ga,pów,A
guzik|ga
gwałciciel|ga,A,P,*nominative.pl=gwałciciele,*vocative.pl=gwałciciele
gwiazda|*dative.sg=gwieździe,*locative.sg=gwieździe
gwizdek|ga
gwóźdź|sgwóździ,ga,pi
hacham|ga,nowie,A,P
haczyk|ga
hadron|ga
hak|ga
haki|cn,*genitive.sg=haków,*dative.sg=hakom,*instrumental.sg=hakami,*locative.sg=hakach
hala|p
halerz|ga,A
halibut|ga,A
hamak|ga
hamburger|ga,A
hamulec|ga,pów
harmonia|*genitive.sg=harmonii,*genitive.pl=harmonii,*dative.sg=harmonii,*locative.sg=harmonii
haszcze|*genitive.sg=haszczy,*dative.sg=haszczom,*instrumental.sg=haszczami,*locative.sg=haszczach
haubica|p
headshot|ga
hebel|shebl,ga
hedonista|pów,P,*nominative.pl=hedoniści,*accusative.pl=hedonistów,*vocative.pl=hedoniści
heheszki|cn,*genitive.sg=heheszek,*dative.sg=heheszkom,*instrumental.sg=heheszkami,*locative.sg=heheszkach
hejter|ga,A,P
hektar|ga
helikopter|ga
henr|ga
herc|ga,pów
hierarcha|nowie,pów,P,*genitive.sg=hierarchy,*accusative.pl=hierarchów
hierarchia|*genitive.sg=hierarchii,*dative.sg=hierarchii,*locative.sg=hierarchii
hierarchini|cf,shierarchini,*genitive.pl=hierarchiń,*vocative.sg=hierarchini
hindus|ga,ni,A,P
hiperbola|p
hipis|ga,ni,A,P
hipopotam|ga,A
histologia|*genitive.sg=histologii,*dative.sg=histologii,*locative.sg=histologii
histopatologia|*genitive.sg=histopatologii,*dative.sg=histopatologii,*locative.sg=histopatologii
historia|*genitive.sg=historii,*dative.sg=historii,*locative.sg=historii
historyk|ga,A,P
hiszpan|ga,nie,A,P
hodowca|ny,pów,P,*accusative.pl=hodowców
hokeista|pów,P,*nominative.pl=hokeiści,*accusative.pl=hokeistów,*vocative.pl=hokeiści
holender|sHolendr,ga,A,P
holownik|ga
homar|ga,A
homoseksualista|pów,P,*nominative.pl=homoseksualiści,*accusative.pl=homoseksualistów,*vocative.pl=homoseksualiści
homoseksualność|ck
hostia|*genitive.sg=hostii,*dative.sg=hostii,*locative.sg=hostii
house|*genitive.sg=house'u,*dative.sg=house'owi,*instrumental.sg=house'em,*vocative.sg=housie
hrabia|nowie,A,*genitive.sg=hrabiego,*genitive.pl=hrabich,*dative.sg=hrabiemu,*accusative.sg=hrabiego,*accusative.pl=hrabiów
hrywna|*genitive.pl=hrywien
humanista|pów,P,*nominative.pl=humaniści,*accusative.pl=humanistów,*vocative.pl=humaniści
husyta|pów,P,*nominative.pl=husyci,*accusative.pl=husytów,*vocative.pl=husyci
hydraulik|ga,A,P
hydrofitologia|*genitive.sg=hydrofitologii,*dative.sg=hydrofitologii,*locative.sg=hydrofitologii
hydrogeologia|*genitive.sg=hydrogeologii,*dative.sg=hydrogeologii,*locative.sg=hydrogeologii
hydroklimatologia|*genitive.sg=hydroklimatologii,*dative.sg=hydroklimatologii,*locative.sg=hydroklimatologii
hydrometeorologia|*genitive.sg=hydrometeorologii,*dative.sg=hydrometeorologii,*locative.sg=hydrometeorologii
ibis|ga,A
ibook|ga
ichtiolog|ga,A,P
ichtiopatologia|*genitive.sg=ichtiopatologii,*dative.sg=ichtiopatologii,*locative.sg=ichtiopatologii
identyczność|ck,ni,P
ideolog|ga,A,P
idiota|pów,P,*nominative.pl=idioci,*accusative.pl=idiotów,*vocative.pl=idioci
idol|ga,A,P,*nominative.pl=idole,*vocative.pl=idole
igrek|sigrek,ga
igrzyska|cn,*genitive.sg=igrzysk,*dative.sg=igrzyskom,*instrumental.sg=igrzyskami,*locative.sg=igrzyskach
ilość|ck,ni,P
imac|ga,pów,*nominative.pl=iMaki,*accusative.pl=iMaki,*instrumental.sg=iMakiem,*vocative.pl=iMaki
imbryk|ga
imię|simion,*genitive.sg=imienia,*dative.sg=imieniu,*instrumental.sg=imieniem,*locative.sg=imieniu
immunologia|*genitive.sg=immunologii,*dative.sg=immunologii,*locative.sg=immunologii
immunopatologia|*genitive.sg=immunopatologii,*dative.sg=immunopatologii,*locative.sg=immunopatologii
imperator|ga,A,P
indianin|ga,A,P
indonezyjczyk|ga,A,P
indyk|ga,A
informacja|*genitive.pl=informacyj
informatyk|ga,A,P
interlingua|sinterlingw,p
internista|pów,P,*nominative.pl=interniści,*accusative.pl=internistów,*vocative.pl=interniści
introligator|ga,A,P
inwalida|pów,P,*nominative.pl=inwalidzi,*accusative.pl=inwalidów,*vocative.pl=inwalidzi
inżynier|ga,A,P
iphone|cm,siPhone',ga,*locative.sg=iPhonie,*vocative.sg=iPhonie
ipod|ga
irakijczyk|ga,A,P
irlandczyk|ga,A,P
ironia|*genitive.sg=ironii,*dative.sg=ironii,*locative.sg=ironii
iskra|*genitive.pl=iskier
islandczyk|ga,A,P
istnienie|*genitive.pl=istnień
izraelczyk|ga,A,P
jabłecznik|ga
jabłoń|ck
jabol|ga
jagnię|sjagnięt,*genitive.sg=jagnięcia,*genitive.pl=jagniąt,*dative.sg=jagnięciu,*instrumental.sg=jagnięciem,*locative.sg=jagnięciu
jagoda|*genitive.pl=jagód
jaguar|ga,A
jajecznica|p
jajnik|ga
jałmużna|p
jałowiec|ga,pów,A
jamnik|ga,A
jamochłon|ga,A
janczar|ga,A,P
janowiec|ga,pów
janusz|ga,A,P,*nominative.pl=janusze,*vocative.pl=janusze
japoniec|sjapońc,ga,ny,pów,A,P,*vocative.sg=japończe
japończyk|ga,A,P
jarząbek|sjarząbk,ga,A
jarzynowa|ne,*genitive.sg=jarzynowej,*genitive.pl=jarzynowych,*dative.sg=jarzynowej,*dative.pl=jarzynowym,*accusative.sg=jarzynową,*instrumental.pl=jarzynowymi,*locative.sg=jarzynowej,*locative.pl=jarzynowych,*vocative.sg=jarzynowa
jaskinia|*genitive.pl=jaskiń
jastrząb|sjastrzębi,ga,pi,A
jaszczur|ga,A
jaśminowiec|ga,pów
jazda|*dative.sg=jeździe,*locative.sg=jeździe
jaźń|ck
jaźwiec|ga,pów,A
jądro|*genitive.pl=jąder
jebaka|pów,P,*nominative.pl=jebacy,*accusative.pl=jebaków,*vocative.pl=jebacy
jednokładność|ck,ni,P
jednorożec|ga,pów,A
jedwabnik|ga,A
jedynak|ga,A,P
jehowiec|ga,ny,pów,A,P,*vocative.sg=jehowcze
jehowy|cn,ni,A,P,*genitive.sg=jehowego,*genitive.pl=jehowych,*dative.sg=jehowemu,*dative.pl=jehowym,*accusative.sg=jehowego,*accusative.pl=jehowych,*instrumental.sg=jehowym,*instrumental.pl=jehowymi,*locative.sg=jehowym,*locative.pl=jehowych
jeleń|ga,A
jen|ga,A
jeniec|sjeńc,ga,ny,pów,A,P
jerzyk|ga,A
jesiotr|ga,A
jeździec|sjeźdźc,ga,ny,pów,A,P,*vocative.sg=jeźdźcze
jeż|ga,A
jeżowiec|ga,pów,A
jeżozwierz|ga,A
jeżyk|ga,A
jędza|p
języczek|ga
język|ga
językoznawca|ny,pów
joker|ga,A
joypad|ga
jubiler|ga,A,P
jucha|*genitive.sg=juchy
junak|ga,A,P
jupiter|ga
jurek|ga,nowie,A,P
kabaczek|ga
kabanos|ga,A
kabel|skabl,ga
kabriolet|ga
kac|ga,pów,A
kacap|ga,A,P,*nominative.pl=kacapy,*vocative.pl=kacapy
kacenjamer|ga
kaczę|skaczęt,*genitive.sg=kaczęcia,*genitive.pl=kacząt,*dative.sg=kaczęciu,*instrumental.sg=kaczęciem,*locative.sg=kaczęciu
kadet|ga,A,P,*nominative.pl=kadeci,*vocative.pl=kadeci
kadłub|ga
kadź|ck
kaganiec|skagańc,ga,pów
kajak|ga
kajdanki|cn,*genitive.sg=kajdanek,*dative.sg=kajdankom,*instrumental.sg=kajdankami,*locative.sg=kajdankach
kajman|ga,A
kakaowiec|ga,pów
kaktus|ga
kalafior|ga
kalendarz|ga
kalif|ga,nowie,A,P
kalkulator|ga
kalmar|ga,A
kalosz|ga
kalwinista|pów,P,*nominative.pl=kalwiniści,*accusative.pl=kalwinistów,*vocative.pl=kalwiniści
kałamarz|ga
kałuża|p
kameleon|ga,A
kamerzysta|pów,P,*nominative.pl=kamerzyści,*accusative.pl=kamerzystów,*vocative.pl=kamerzyści
kamieniarz|ga,A,P,*nominative.pl=kamieniarze,*vocative.pl=kamieniarze
kamienica|p
kamień|ga
kamyk|ga
kanadyjczyk|ga,A,P
kanar|ga,A,P
kanarek|ga,A
kandydat|ga,A,P,*nominative.pl=kandydaci,*vocative.pl=kandydaci
kangur|ga,A
kania|*genitive.pl=kań
kantar|ga
kapeć|skapci,ga,pi
kapela|p
kapelan|ga,ni,A,P
kapelusz|ga
kapitalista|pów,P,*nominative.pl=kapitaliści,*accusative.pl=kapitalistów,*vocative.pl=kapitaliści
kapitan|ga,nowie,A,P
kapitel|skapitl,ga
kaplica|p
kapłan|ga,ni,A,P
kaptur|ga
kapuś|ga,A,P,*nominative.pl=kapusie,*vocative.pl=kapusie
karabinek|ga
karaluch|ga,ny,A,*instrumental.sg=karaluchem
karaś|ga,A
karat|ga
karbieniec|skarbieńc,ga,pów
karczoch|ga,ny,A,*instrumental.sg=karczochem
kardiochirurg|ga,A,P
kardiolog|ga,A,P
karman|ga
karmnik|ga
karnista|pów,P,*nominative.pl=karniści,*accusative.pl=karnistów,*vocative.pl=karniści
karo|cm,skar,ga,na,p
karoseria|*genitive.sg=karoserii,*dative.sg=karoserii,*locative.sg=karoserii
karp|skarpi,ga,pi,A
kartofel|skartofl,ga
kartograf|ga,nowie,A,P
karzeł|skarł,ga,A
kasiarz|ga,A,P,*nominative.pl=kasiarze,*vocative.pl=kasiarze
kasjer|ga,A,P
kaskader|ga,A,P
kasownik|ga
kastrat|ga,A,P,*nominative.pl=kastraci,*vocative.pl=kastraci
kasza|p
kaszalot|ga,A
kaszlak|ga,A
kasztan|ga
kasztanowiec|ga,pów
kat|ga,du,A,P,*nominative.pl=kaci,*vocative.pl=kaci
katabas|ga,ni,A,P
katalizator|ga
katalończyk|ga,A,P
kategoria|*genitive.sg=kategorii,*dative.sg=kategorii,*locative.sg=kategorii
katol|ga,na,A,P
kauczukowiec|ga,pów
kawaler|ga,nowie,A,P
kawalik|ga
kawałek|ga
kawon|ga
kawowiec|ga,pów
kazanie|*genitive.pl=kazań
kaznodzieja|P,*genitive.sg=kaznodziei,*genitive.pl=kaznodziei,*dative.sg=kaznodziei,*accusative.pl=kaznodziei,*locative.sg=kaznodziei
kądziel|ck
kąpiel|ck
kąt|skąt,ga
kciuk|ga
kebs|ga,A
kelner|ga,A,P
kelwin|ga
kibel|skibl,ga
kibic|ga,pów,A,P,*nominative.pl=kibice,*vocative.pl=kibice
kibol|ga,A,P,*nominative.pl=kibole,*vocative.pl=kibole
kicia|pi,*vocative.sg=kiciu
kielich|ga,ny,*instrumental.sg=kielichem
kieliszek|ga
kieł|skł,ga
kiełb|skiełbi,ga,pi,A
kier|ga
kierowca|ny,pów,P,*accusative.pl=kierowców
kierownica|p
kieszeń|ck
kieszonkowiec|ga,ny,pów,A,P
kij|ga,pów
kikut|ga
kilogram|ga
kilometr|ga
kitajec|ga,ny,pów,A,P
kitel|skitl,ga
klacz|ck
klaun|ga,ni,A,P
klawisz|ga
klątwa|p
klecha|ny,pów,P,*genitive.sg=klechy,*accusative.pl=klechów
kleć|ck
klej|pów
kleptomania|*genitive.sg=kleptomanii,*dative.sg=kleptomanii,*locative.sg=kleptomanii
kleszcz|ga,A
klęska|p
klimatologia|*genitive.sg=klimatologii,*dative.sg=klimatologii,*locative.sg=klimatologii
kliper|sklipr,ga
klop|ga
klops|ga,A
klown|ga,ni,A,P
klucz|ga
kluski|cn,*genitive.sg=klusek,*dative.sg=kluskom,*instrumental.sg=kluskami,*locative.sg=kluskach
kłak|ga
kłamca|ny,pów,P,*accusative.pl=kłamców
kłamstwo|p
kłębek|ga
kłoda|*genitive.pl=kłód
kłos|ga
kłusownik|ga,A,P
kłykieć|skłykci,ga,pi
knebel|sknebl,ga
kniahini|cf,skniahini,*genitive.pl=kniahiń,*vocative.sg=kniahini
kniaź|ga,A,P,*nominative.pl=kniazie,*vocative.pl=kniazie
knot|ga
knur|ga,A
koc|ga,pów
kochanek|ga,nowie,A,P
kochanie|*genitive.pl=kochań
kociak|ga,A
kocica|p
kocię|skocięt,*genitive.sg=kocięcia,*genitive.pl=kociąt,*dative.sg=kocięciu,*instrumental.sg=kocięciem,*locative.sg=kocięciu
kocioł|skotł,ga
kociołek|ga
kocur|ga,A
kogucik|ga,A
kogut|ga,A
kojot|ga,A
kok|ga
kokornak|ga
kokosy|cn,*genitive.sg=kokosów,*dative.sg=kokosom,*instrumental.sg=kokosami,*locative.sg=kokosach
kokosz|ck
kolarz|ga,A,P,*nominative.pl=kolarze,*vocative.pl=kolarze
kolczyk|ga
kolec|ga,pów
kolega|pów,P,*nominative.pl=koledzy,*accusative.pl=kolegów,*vocative.pl=koledzy
kolej|ck,*genitive.sg=kolei,*genitive.pl=kolei,*dative.sg=kolei,*locative.sg=kolei,*vocative.sg=kolei
kolejarz|ga,A,P,*nominative.pl=kolejarze,*vocative.pl=kolejarze
kolesław|ga
koliber|skolibr,ga,A
kolonia|*genitive.sg=kolonii,*genitive.pl=kolonii,*dative.sg=kolonii,*locative.sg=kolonii
kolonista|pów,P,*nominative.pl=koloniści,*accusative.pl=kolonistów,*vocative.pl=koloniści
kolos|ga,A,P,*nominative.pl=kolosy,*vocative.pl=kolosy
kolumna|p
kołacz|ga
kołdra|*genitive.pl=kołder
kołnierz|ga
koło|*genitive.pl=kół
kołodziej|ga,pów,A,P,*nominative.pl=kołodzieje,*vocative.pl=kołodzieje
kołowrotek|ga
kołpak|ga
komar|ga,A
kombinerki|cn,*genitive.sg=kombinerek,*dative.sg=kombinerkom,*instrumental.sg=kombinerkami,*locative.sg=kombinerkach
komedia|*genitive.sg=komedii,*dative.sg=komedii,*locative.sg=komedii
komentarz|ga
komin|ga
kominek|ga
kominiarz|ga,A,P,*nominative.pl=kominiarze,*vocative.pl=kominiarze
komoda|*genitive.pl=komód
komora|*genitive.pl=komór
komp|ga,A
kompilator|ga
kompozytor|ga,A,P
komputer|ga
komputerek|ga
komunista|pów,P,*nominative.pl=komuniści,*accusative.pl=komunistów,*vocative.pl=komuniści
kondensator|ga
konduktor|ga,A,P
konformista|pów,P,*nominative.pl=konformiści,*accusative.pl=konformistów,*vocative.pl=konformiści
konopia|pi
konserwa|p
konsolidator|ga
konstantynopolitańczyk|ga,A,P
kontener|ga
kontusz|ga
konus|ga,ni,A,P
konwalia|*genitive.sg=konwalii,*genitive.pl=konwalii,*dative.sg=konwalii,*locative.sg=konwalii
kopacz|ga,A,P,*nominative.pl=kopacze,*vocative.pl=kopacze
kopalnia|*genitive.pl=kopalń
kopciuszek|ga,A
koper|skopr
kopiec|ga,pów
kopnięcie|*genitive.pl=kopnięć
kopt|ga,nowie,A,P
korab|skorabi,ga,pi
kord|ga
koreańczyk|ga,A,P
korek|ga
korkociąg|skorkociąg
kormoran|ga,A
kornik|ga,A
kornwalijczyk|ga,A,P
koronnik|ga,A
korsarz|ga,A,P,*nominative.pl=korsarze,*vocative.pl=korsarze
korytarz|ga
korzeń|ga
korzyść|ck,ni,P
kos|ga,A
kosaciec|skosaćc,ga,pów,A
kosarz|ga,A
kosiarz|ga,A,P,*nominative.pl=kosiarze,*vocative.pl=kosiarze
kosisko|p,*instrumental.sg=kosiskem
kosmonauta|pów,P,*nominative.pl=kosmonauci,*accusative.pl=kosmonautów,*vocative.pl=kosmonauci
kosmopolita|pów,P,*nominative.pl=kosmopolici,*accusative.pl=kosmopolitów,*vocative.pl=kosmopolici
kosmyk|ga
kosowianin|ga,A,P
kostnica|p
kostucha|ny,*genitive.sg=kostuchy
kosz|ga
koszula|p
koszyk|ga
koszykarz|ga,A,P,*nominative.pl=koszykarze,*vocative.pl=koszykarze
kościół|ga,*locative.sg=kościele,*vocative.sg=kościele
kość|ck,ni,P,*instrumental.pl=kośćmi
kot|ga,du,A
koteczek|ga,A
kotek|ga,A
kotlet|ga
kotwica|p
kowal|ga,A,P,*nominative.pl=kowale,*vocative.pl=kowale
koza|*genitive.pl=kóz
kozak|ga,A,P
kozica|p
koziorożec|ga,pów,A
kozłek|ga
kozojebca|ny,pów,P,*accusative.pl=kozojebców
kożuch|ga,ny,*instrumental.sg=kożuchem
krab|ga,A
krach|ny,*instrumental.sg=krachem
kradzież|ck
kraj|pów
krajan|ga,nie,A,P
krakus|ga,A,P,*nominative.pl=krakusy,*vocative.pl=krakusy
krasnal|ga,A
krasula|p
krawat|ga
krawcowa|ne,*genitive.sg=krawcowej,*genitive.pl=krawcowych,*dative.sg=krawcowej,*dative.pl=krawcowym,*accusative.sg=krawcową,*instrumental.pl=krawcowymi,*locative.sg=krawcowej,*locative.pl=krawcowych
krawędź|ck
krawiec|ga,ny,pów,A,P
krążownik|ga
kreator|ga
kret|ga,A
kretyn|ga,ni,A,P
krewna|ne,*genitive.sg=krewnej,*genitive.pl=krewnych,*dative.sg=krewnej,*dative.pl=krewnym,*accusative.sg=krewną,*instrumental.pl=krewnymi,*locative.sg=krewnej,*locative.pl=krewnych,*vocative.sg=krewna
krewny|cn,ni,A,P,*genitive.sg=krewnego,*genitive.pl=krewnych,*dative.sg=krewnemu,*dative.pl=krewnym,*accusative.sg=krewnego,*accusative.pl=krewnych,*instrumental.sg=krewnym,*instrumental.pl=krewnymi,*locative.sg=krewnym,*locative.pl=krewnych
kręgiel|skręgl,ga
kręgle|*genitive.sg=kręgli,*dative.sg=kręglom,*instrumental.sg=kręglami,*locative.sg=kręglach
kręgosłup|ga
kręgowiec|ga,pów,A
krętogłów|ga,A
krocze|py
krogulec|ga,pów,A
krokiet|ga,A
krokodyl|ga,A
krokus|ga
kronikarz|ga,A,P,*nominative.pl=kronikarze,*vocative.pl=kronikarze
krosno|*genitive.pl=krosien
krowa|*genitive.pl=krów
krowianka|*dative.sg=krowniace
królewicz|ga,A,P,*nominative.pl=królewicze,*vocative.pl=królewicze
królik|ga,A
krtań|ck
kruczek|ga
kruk|ga,A
kruszczyk|ga
kruszec|pów
krwawnica|p
krwawnik|ga
kryminalista|pów,P,*nominative.pl=kryminaliści,*accusative.pl=kryminalistów,*vocative.pl=kryminaliści
krynica|p
kryptografia|*genitive.sg=kryptografii,*dative.sg=kryptografii,*locative.sg=kryptografii
kryptologia|*genitive.sg=kryptologii,*dative.sg=kryptologii,*locative.sg=kryptologii
krystalografia|*genitive.sg=krystalografii,*dative.sg=krystalografii,*locative.sg=krystalografii
krzeczot|ga,A
krzemian|*instrumental.sg=krzemianen
krzemień|ga
krzywa|ne,*genitive.sg=krzywej,*genitive.pl=krzywych,*dative.sg=krzywej,*dative.pl=krzywym,*accusative.sg=krzywą,*instrumental.pl=krzywymi,*locative.sg=krzywej,*locative.pl=krzywych,*vocative.sg=krzywa
krzyż|ga
krzyżyk|ga
ksiądz|sksięż,na,A,P,*genitive.sg=księdza,*dative.sg=księdzu,*accusative.sg=księdza,*instrumental.sg=księdzem,*instrumental.pl=księżmi,*locative.sg=księdzu,*vocative.sg=księże
książę|sksiążęt,A,P,*genitive.sg=księcia,*genitive.pl=książąt,*dative.sg=księciu,*accusative.sg=księcia,*accusative.pl=książąt,*instrumental.sg=księciem,*locative.sg=księciu
księga|*genitive.pl=ksiąg
księgowa|ne,*genitive.sg=księgowej,*genitive.pl=księgowych,*dative.sg=księgowej,*dative.pl=księgowym,*accusative.sg=księgową,*instrumental.pl=księgowymi,*locative.sg=księgowej,*locative.pl=księgowych
księgowy|cn,ni,A,P,*genitive.sg=księgowego,*genitive.pl=księgowych,*dative.sg=księgowemu,*dative.pl=księgowym,*accusative.sg=księgowego,*accusative.pl=księgowych,*instrumental.sg=księgowym,*instrumental.pl=księgowymi,*locative.sg=księgowym,*locative.pl=księgowych
księżyc|ga,pów
kszyk|ga,A
kubek|ga
kubeł|skubł,ga
kuc|ga,pów,A
kucharz|ga,A,P,*nominative.pl=kucharze,*vocative.pl=kucharze
kufel|skufl,ga
kufer|skufr,ga
kujon|ga,ni,A,P
kukurydza|py
kula|p
kulomb|ga
kulon|ga,A
kulturysta|pów,P,*nominative.pl=kulturyści,*accusative.pl=kulturystów,*vocative.pl=kulturyści
kumkwat|ga
kumpel|skumpl,ga,A,P,*nominative.pl=kumple,*vocative.pl=kumple
kundel|skundl,ga,A
kuper|skupr,ga
kupiec|ga,ny,pów,A,P
kur|ga,A
kurator|ga,A,P
kurczak|ga,A
kurczę|skurczęt,*genitive.sg=kurczęcia,*genitive.pl=kurcząt,*dative.sg=kurczęciu,*instrumental.sg=kurczęciem,*locative.sg=kurczęciu
kurek|ga
kurewstwo|p
kurnik|ga
kuropatwa|p
kurwy|cn,*genitive.sg=kurew,*dative.sg=kurwom,*instrumental.sg=kurwami,*locative.sg=kurwach
kusiciel|ga,A,P,*nominative.pl=kusiciele,*vocative.pl=kusiciele
kusza|p
kuśnierz|ga,A,P,*nominative.pl=kuśnierze,*vocative.pl=kuśnierze
kutafon|ga,ni,A,P,*vocative.pl=kutafony
kutas|ga,A
kutia|*genitive.sg=kutii,*dative.sg=kutii,*locative.sg=kutii
kuzyn|ga,ni,A,P
kwadrans|ga
kwarc|pów
kwark|ga
kwiaciarz|ga,A,P,*nominative.pl=kwiaciarze,*vocative.pl=kwiaciarze
kwiat|*locative.sg=kwiecie,*vocative.sg=kwiecie
kwiatek|ga
kwiatuszek|ga
kwiczoł|ga,A
kwiecień|skwietni,ga,pów
label|ga
laik|ga,A,P
lakiernik|ga,A,*nominative.pl=lakiernicy,*accusative.pl=lakiernicy,*vocative.pl=lakiernicy
lampart|ga,A
lantanowiec|ga,pów
larwa|p
laryngolog|ga,A,P
las|*locative.sg=lesie,*vocative.sg=lesie
laser|ga
latarnik|ga,A,P
latarniowiec|ga,pów
latawiec|ga,pów
ląd|sląd
lądowanie|*genitive.pl=lądowań
lądowisko|p
legar|ga
legionista|pów,P,*nominative.pl=legioniści,*accusative.pl=legionistów,*vocative.pl=legioniści
lejek|ga
lekarz|ga,A,P,*nominative.pl=lekarze,*vocative.pl=lekarze
lekkoatleta|pów,P,*nominative.pl=lekkoatleci,*accusative.pl=lekkoatletów,*vocative.pl=lekkoatleci
leksykografia|*genitive.sg=leksykografii,*dative.sg=leksykografii,*locative.sg=leksykografii
lelek|ga,A
lemiesz|ga
leming|ga,A
lemur|ga,A
len|sln
leniwiec|ga,pów,A
leń|ga,A,P,*nominative.pl=lenie,*vocative.pl=lenie
leszcz|ga,A
lewak|ga,A,P
liberia|*genitive.sg=liberii,*dative.sg=liberii,*locative.sg=liberii
licealista|pów,P,*nominative.pl=licealiści,*accusative.pl=licealistów,*vocative.pl=licealiści
licho|*instrumental.sg=lichem
lichwiarz|ga,A,P,*nominative.pl=lichwiarze,*vocative.pl=lichwiarze
liczebnik|ga
liczebność|ck
licznik|ga
lider|ga,A,P
likaon|ga,A
lin|ga,A
lingwista|pów,P,*nominative.pl=lingwiści,*accusative.pl=lingwistów,*vocative.pl=lingwiści
linia|*genitive.sg=linii,*genitive.pl=linii,*dative.sg=linii,*locative.sg=linii
lipiec|ga,pów
lis|ga,A
lisica|p
lisię|slisięt,*genitive.sg=lisięcia,*genitive.pl=lisiąt,*dative.sg=lisięciu,*instrumental.sg=lisięciem,*locative.sg=lisięciu
lista|*nominative.sg=list
listek|ga
listonosz|ga,A,*accusative.pl=listonoszów
listopad|ga
liszaj|ga,pów
liść|ga
litr|ga
lizak|ga
lnica|p
lobelia|*genitive.sg=lobelii,*genitive.pl=lobelii,*dative.sg=lobelii,*locative.sg=lobelii
loch|ny,*instrumental.sg=lochem
locha|ny,*genitive.sg=lochy
lodołamacz|ga
lodowiec|ga,pów
lodowisko|p
lody|cn,*genitive.sg=lodów,*dative.sg=lodom,*instrumental.sg=lodami,*locative.sg=lodach
lodzik|ga
logomachia|*genitive.sg=logomachii,*dative.sg=logomachii,*locative.sg=logomachii
logopeda|pów,P,*nominative.pl=logopedzi,*accusative.pl=logopedów,*vocative.pl=logopedzi
logopedia|*genitive.sg=logopedii,*dative.sg=logopedii,*locative.sg=logopedii
lokator|ga,A,P
londyńczyk|ga,A,P
lonża|p
loteria|*genitive.sg=loterii,*dative.sg=loterii,*locative.sg=loterii
lotniskowiec|ga,pów
lubrykant|ga
lucerna|p
ludojad|ga,A
ludożerca|ny,pów,P,*accusative.pl=ludożerców
lufcik|ga
luks|ga
lulek|ga
lumen|ga
lunatyk|ga,A,P
lustro|*genitive.pl=luster
lutnik|ga,A,P
lutownica|p
luty|cn,ne,*genitive.sg=lutego,*genitive.pl=lutych,*dative.sg=lutemu,*dative.pl=lutym,*instrumental.sg=lutym,*instrumental.pl=lutymi,*locative.sg=lutym,*locative.pl=lutych
lwica|p
lwię|slwięt,*genitive.sg=lwięcia,*genitive.pl=lwiąt,*dative.sg=lwięciu,*instrumental.sg=lwięciem,*locative.sg=lwięciu
łabądź|ga,A
łabędź|ga,A
łagiew|słagwi,gi,di,li,pi,*instrumental.sg=łagwią
łakomstwo|p
łamana|ne,*genitive.sg=łamanej,*genitive.pl=łamanych,*dative.sg=łamanej,*dative.pl=łamanym,*accusative.sg=łamaną,*instrumental.pl=łamanymi,*locative.sg=łamanej,*locative.pl=łamanych,*vocative.sg=łamana
łania|*genitive.pl=łań
łańcuch|ga,ny,*instrumental.sg=łańcuchem
łasica|p
łaska|p
łącze|py
łeb|słb,ga
łeż|ck,słż
łgarz|ga,A,P,*nominative.pl=łgarze,*vocative.pl=łgarze
łodzik|ga,A
łokieć|słokci,ga,pi
łosiek|słośk,ga,A
łosoś|ga,A
łoś|ga,A
łotr|ga,A,P
łotysz|ga,A,P,*nominative.pl=Łotysze,*vocative.pl=Łotysze
łowca|ny,pów,P,*accusative.pl=łowców
łoże|py
łódź|ck
łój|pów
łucznik|ga,A,P
łycha|ny,*genitive.sg=łychy
łysol|ga,A,P,*nominative.pl=łysole,*vocative.pl=łysole
łza|*genitive.pl=łez
macbook|ga
macedończyk|ga,A,P
macica|p
macintosh|ga,lu,ne,py,A
macocha|ny,*genitive.sg=macochy
mag|ga,nowie,A,P
magazynier|ga,A,P
magnolia|*genitive.sg=magnolii,*genitive.pl=magnolii,*dative.sg=magnolii,*locative.sg=magnolii
mahoniowiec|ga,pów
maj|ga,pów
maj|ga,pów,A,P,*nominative.pl=Majówie,*vocative.pl=Majówie
makak|ga,A
makaroniarz|ga,A,P,*nominative.pl=makaroniarze,*vocative.pl=makaroniarze
makia|*genitive.sg=makii,*dative.sg=makii,*locative.sg=makii
makler|ga,A,P
makolągwa|p
makowiec|ga,pów,A
makrela|p
malarz|ga,A,P,*nominative.pl=malarze,*vocative.pl=malarze
malowanie|*genitive.pl=malowań
maluch|ga,ny,A,*instrumental.sg=maluchem
małż|ga,A
małżonek|ga,nowie,A,P
mamer|smamr,ga
mamusia|*genitive.pl=mamuś,*vocative.sg=mamusiu
mamut|ga,A
manat|ga,A
mandaryn|ga,ni,A,P
manele|*genitive.sg=maneli,*dative.sg=manelom,*instrumental.sg=manelami,*locative.sg=manelach
manicure|cm,smanicure',*locative.sg=manicurze,*vocative.sg=manicurze
mańkut|ga,A,P,*nominative.pl=mańkuci,*vocative.pl=mańkuci
marakuja|p,*genitive.sg=marakui,*dative.sg=marakui,*locative.sg=marakui
marchewnik|ga
marchia|*genitive.sg=marchii,*dative.sg=marchii,*locative.sg=marchii
marker|ga
marność|ck,ni,P,*dative.sg=marnośći
marsjanin|ga,A,P
marskość|ck,ni,P
marszałek|ga,nowie,A,P
marszand|ga,A
martwica|p
marycha|*genitive.sg=marychy
marynarz|ga,A,P,*nominative.pl=marynarze,*vocative.pl=marynarze
marzec|smarc,ga,pów
marzenie|*genitive.pl=marzeń
marzyciel|ga,A,P,*nominative.pl=marzyciele,*vocative.pl=marzyciele
masażysta|pów,P,*nominative.pl=masażyści,*accusative.pl=masażystów,*vocative.pl=masażyści
maskonur|ga,A
maskowanie|*genitive.pl=maskowań
masochista|pów,P,*nominative.pl=masochiści,*accusative.pl=masochistów,*vocative.pl=masochiści
masowiec|ga,pów
mastektomia|*genitive.sg=mastektomii,*dative.sg=mastektomii,*locative.sg=mastektomii
maszynista|pów,P,*nominative.pl=maszyniści,*accusative.pl=maszynistów,*vocative.pl=maszyniści
maść|ck,ni,P
matematyk|ga,A,P
materac|ga,pów
matkojebca|ny,pów,P,*accusative.pl=matkojebców
matryca|p
mazgaj|ga,pów,A,P,*nominative.pl=mazgaje,*vocative.pl=mazgaje
maź|ck
mąciciel|ga,A,P,*nominative.pl=mąciciele,*vocative.pl=mąciciele
mącznica|p
mądrość|ck,ni,P
mątwa|p
mąż|ga,nowie,pów,A,P
mebel|smebl,ga
mech|smch,ny,*instrumental.sg=mchem
mechanik|ga,A,P
mecz|pów
medalista|pów,P,*nominative.pl=medaliści,*accusative.pl=medalistów,*vocative.pl=medaliści
mejl|ga
melancholik|ga,A,P
melodia|*genitive.sg=melodii,*dative.sg=melodii,*locative.sg=melodii
melon|ga
melonik|ga
menel|ga,A
menuet|ga
mercedes|ga,A
metalurgia|*genitive.sg=metalurgii,*dative.sg=metalurgii,*locative.sg=metalurgii
meteor|ga
meteorolog|ga,A,P
metodologia|*genitive.sg=metodologii,*dative.sg=metodologii,*locative.sg=metodologii
metr|ga
metropolita|pów,P,*nominative.pl=metropolici,*accusative.pl=metropolitów,*vocative.pl=metropolici
męczennica|p
męczennik|ga,A,P
mędrzec|smędrc,ga,ny,pów,A,P,*vocative.sg=mędrcze
mężczyzna|p,P,*nominative.pl=mężczyźni,*accusative.pl=mężczyzn,*vocative.pl=mężczyźni
mgławica|p
mianownik|ga
miara|*dative.sg=mierze,*locative.sg=mierze
miasto|*locative.sg=mieście
miech|ga,ny,*instrumental.sg=miechem
miecznik|ga,A
miednica|p
miedza|p
miedziak|ga,A
miejsce|p
miejscownik|ga
miesiąc|smiesiąc,ga,*genitive.pl=miesięcy
mieszkanie|*genitive.pl=mieszkań
mieszkaniec|smieszkańc,ga,ny,pów,A,P
mięczak|ga,A
mięsień|smięśni,ga,pi
mięsożerca|ny,pów,P,*accusative.pl=mięsożerców
miętus|ga,A
migdał|ga
migdałowiec|ga,pów
mikrokontroler|ga
mikrometr|ga
mila|p
miliarder|ga,A,P
milicjant|ga,A,P,*nominative.pl=milicjanci,*vocative.pl=milicjanci
miligram|ga
milimetr|ga
milioner|ga,A,P
miłek|ga
miłość|ck,ni,P
miłośnik|ga,A,P
minimalista|pów,P,*nominative.pl=minimaliści,*accusative.pl=minimalistów,*vocative.pl=minimaliści
mintaj|ga,pów,A,*nominative.pl=mintaj
minus|ga
misjonarz|ga,A,P,*nominative.pl=misjonarze,*vocative.pl=misjonarze
mister|ga,A,P
mistrz|ga,nowie,pów,A,P
miśki|cn,*genitive.sg=miśków,*dative.sg=miśkom,*instrumental.sg=miśkami,*locative.sg=miśkach
mitologia|*genitive.sg=mitologii,*dative.sg=mitologii,*locative.sg=mitologii
mizeria|*genitive.sg=mizerii,*dative.sg=mizerii,*locative.sg=mizerii
mizoginia|*genitive.sg=mizoginii,*dative.sg=mizoginii,*locative.sg=mizoginii
mleczarz|ga,A,P,*nominative.pl=mleczarze,*vocative.pl=mleczarze
młode|ne,*genitive.sg=młodego,*genitive.pl=młodych,*dative.sg=młodemu,*dative.pl=młodym,*instrumental.sg=młodym,*instrumental.pl=młodymi,*locative.sg=młodym,*locative.pl=młodych
młot|ga
młotek|ga
młyn|ga
młynarz|ga,A,P,*nominative.pl=młynarze,*vocative.pl=młynarze
mnich|ga,A,P,*nominative.pl=mnisi,*instrumental.sg=mnichem,*vocative.pl=mnisi
mniejszość|ck,ni,P
mnożenie|*genitive.pl=mnożeń
mnożnik|ga
moc|ck
mocznik|ga
moda|*genitive.pl=mód
modlitwa|p
modrzew|smodrzewi,ga,pi
modrzewnica|p
mol|ga
monarcha|nowie,pów,P,*genitive.sg=monarchy,*accusative.pl=monarchów
monarchia|*genitive.sg=monarchii,*dative.sg=monarchii,*locative.sg=monarchii
monarchista|pów,P,*nominative.pl=monarchiści,*accusative.pl=monarchistów,*vocative.pl=monarchiści
monitor|ga
monogamia|*genitive.sg=monogamii,*dative.sg=monogamii,*locative.sg=monogamii
monopolista|pów,P,*nominative.pl=monopoliści,*accusative.pl=monopolistów,*vocative.pl=monopoliści
monoteista|pów,P,*nominative.pl=monoteiści,*accusative.pl=monoteistów,*vocative.pl=monoteiści
montażysta|pów,P,*nominative.pl=montażyści,*accusative.pl=montażystów,*vocative.pl=montażyści
mops|ga,A
morderca|ny,pów,P,*accusative.pl=morderców
morderczyni|cf,smorderczyni,*genitive.pl=morderczyń,*vocative.sg=morderczyni
morderstwo|p
mordobicie|*genitive.pl=mordobić
morela|p
morfologia|*genitive.sg=morfologii,*dative.sg=morfologii,*locative.sg=morfologii
mors|ga,A
morświn|ga,A
morwa|p
morze|*genitive.pl=mórz
moskit|ga,A
mostek|ga
mość|ck,ni,P
motek|ga
motocykl|ga
motorniczy|cn,nowie,A,P,*genitive.sg=motorniczego,*genitive.pl=motorniczych,*dative.sg=motorniczemu,*dative.pl=motorniczym,*accusative.sg=motorniczego,*accusative.pl=motorniczych,*instrumental.sg=motorniczym,*instrumental.pl=motorniczymi,*locative.sg=motorniczym,*locative.pl=motorniczych
motyl|ga,A
motylek|ga,A
mowa|*genitive.pl=mów
możliwość|ck,ni,P
mól|ga,A
mówca|cm,smówc,gy,dy,ly,A,*nominative.sg=mówcy,*nominative.pl=mówcmówców,*accusative.pl=mówcmówców,*instrumental.sg=mówcą,*vocative.pl=mówcmówców
mózg|smózg
móżdżek|smóżdżk,ga
mrówkojad|ga,A
mrówkolew|smrówkolw,ga,A
mrównik|ga,A
msza|py
mszyca|p
mucha|ny,*genitive.sg=muchy
muchomor|ga,A
muezin|ga,ni,A,P
muflon|ga,A
mulczowanie|*genitive.pl=mulczowań
mumia|*genitive.sg=mumii,*dative.sg=mumii,*locative.sg=mumii
mundurek|ga
muranów|ga
murarz|ga,A,P,*nominative.pl=murarze,*vocative.pl=murarze
murzyn|ga,ni,A,P
murzyn|ga,ni,A,P
muslim|ga,nowie,A,P
mutant|ga,A
muzułmanin|ga,pów,A,P
muzyk|ga,A,P
mydlnica|p
mykologia|*genitive.sg=mykologii,*dative.sg=mykologii,*locative.sg=mykologii
mysikrólik|ga,A
mysza|py
myszołów|ga,A
myśl|ck,ni,P
myśliciel|ga,A,P,*nominative.pl=myśliciele,*vocative.pl=myśliciele
myśliwiec|ga,pów
myśliwy|cn,ni,A,P,*genitive.sg=myśliwego,*genitive.pl=myśliwych,*dative.sg=myśliwemu,*dative.pl=myśliwym,*accusative.sg=myśliwego,*accusative.pl=myśliwych,*instrumental.sg=myśliwym,*instrumental.pl=myśliwymi,*locative.sg=myśliwym,*locative.pl=myśliwych
myślnik|ga
nachrapnik|ga
naczynie|*genitive.pl=naczyń
nać|ck
nadawca|ny,pów,P,*accusative.pl=nadawców
nadczłowiek|ga,A,P,*nominative.pl=nadludzie,*genitive.pl=nadludzi,*dative.pl=nadludziom,*accusative.pl=nadludzi,*instrumental.pl=nadludźmi,*locative.pl=nadludziach,*vocative.pl=nadludzie
nadgarstek|ga
nadgorliwość|ck
nadprzewodnik|ga
nadużycie|*genitive.pl=nadużyć
nadzieja|*genitive.sg=nadziei,*genitive.pl=nadziei,*dative.sg=nadziei,*locative.sg=nadziei
nadzorca|ny,pów,P,*accusative.pl=nadzorców
nagietek|ga
nagłówek|snagłówk,ga
nagroda|*genitive.pl=nagród
najemca|ny,pów,P,*accusative.pl=najemców
najemnik|ga,A,P
naleśnik|ga,A
namiętność|ck,ni,P
nanometr|ga
naparstek|ga
naparstnica|p
napastnik|ga,A,P
napięcie|*genitive.pl=napięć
napletek|ga
napój|pów
narciarz|ga,A,P,*nominative.pl=narciarze,*vocative.pl=narciarze
narodowość|ck,ni,P
narząd|snarząd
narzeczona|ne,*genitive.sg=narzeczonej,*genitive.pl=narzeczonych,*dative.sg=narzeczonej,*dative.pl=narzeczonym,*accusative.sg=narzeczoną,*instrumental.pl=narzeczonymi,*locative.sg=narzeczonej,*locative.pl=narzeczonych
narzeczony|cn,A,P,*nominative.pl=narzeczeni,*genitive.sg=narzeczonego,*genitive.pl=narzeczonych,*dative.sg=narzeczonemu,*dative.pl=narzeczonym,*accusative.sg=narzeczonego,*accusative.pl=narzeczonych,*instrumental.sg=narzeczonym,*instrumental.pl=narzeczonymi,*locative.sg=narzeczonym,*locative.pl=narzeczonych,*vocative.pl=narzeczeni
narzekanie|*genitive.pl=narzekań
narzędnik|ga
następnik|ga
nastolatek|ga,A,P,*nominative.pl=nastolatki,*vocative.pl=nastolatki
nastrój|pów
naszyjnik|ga
nauczyciel|ga,A,P,*nominative.pl=nauczyciele,*vocative.pl=nauczyciele
naukowiec|ga,ny,pów,A,P,*vocative.sg=naukowcze
naziol|ga,A,P,*nominative.pl=naziole,*vocative.pl=naziole
nazista|pów,P,*nominative.pl=naziści,*accusative.pl=nazistów,*vocative.pl=naziści
nazwa|p
neon|*accusative.sg=neona
neurologia|*genitive.sg=neurologii,*dative.sg=neurologii,*locative.sg=neurologii
nędza|p
niania|*genitive.pl=niań,*vocative.sg=nianiu
nicień|ga,A
nić|ck,ni,P
niebezpieczeństwo|p
nieboszczyk|ga,A,P
niecierpek|ga
niedopałek|ga
niedorzecznik|ga,A,P
niedziela|p
niedźwiadek|ga,A
niedźwiedzica|p
niedźwiedź|ga,A
niemiec|ga,ny,pów,A,P,*vocative.sg=Niemcze
niemowlę|sniemowlęt,*genitive.sg=niemowlęcia,*genitive.pl=niemowląt,*dative.sg=niemowlęciu,*instrumental.sg=niemowlęciem,*locative.sg=niemowlęciu
niepełnosprawny|cn,ni,A,P,*genitive.sg=niepełnosprawnego,*genitive.pl=niepełnosprawnych,*dative.sg=niepełnosprawnemu,*dative.pl=niepełnosprawnym,*accusative.sg=niepełnosprawnego,*accusative.pl=niepełnosprawnych,*instrumental.sg=niepełnosprawnym,*instrumental.pl=niepełnosprawnymi,*locative.sg=niepełnosprawnym,*locative.pl=niepełnosprawnych
niepewność|ck,ni,P
niepokój|pów,*genitive.sg=niepokoje
nieporządek|snieporządk
niepowodzenie|*genitive.pl=niepowodzeń
nierówność|ck,ni,P
nieruchomość|ck,ni,P
nietoperz|ga,A
nieuk|ga,A,P,*nominative.pl=neuki,*vocative.pl=neuki
niewiadoma|ne,*genitive.sg=niewiadomej,*genitive.pl=niewiadomych,*dative.sg=niewiadomej,*dative.pl=niewiadomym,*accusative.sg=niewiadomą,*instrumental.pl=niewiadomymi,*locative.sg=niewiadomej,*locative.pl=niewiadomych
niewiasta|*dative.sg=niewieście,*locative.sg=niewieście
niewidoma|ne,*genitive.sg=niewidomej,*genitive.pl=niewidomych,*dative.sg=niewidomej,*dative.pl=niewidomym,*accusative.sg=niewidomą,*instrumental.pl=niewidomymi,*locative.sg=niewidomej,*locative.pl=niewidomych,*vocative.sg=niewidoma
niewidomy|cn,ni,A,P,*genitive.sg=niewidomego,*genitive.pl=niewidomych,*dative.sg=niewidomemu,*dative.pl=niewidomym,*accusative.sg=niewidomego,*accusative.pl=niewidomych,*instrumental.sg=niewidomym,*instrumental.pl=niewidomymi,*locative.sg=niewidomym,*locative.pl=niewidomych
niewolnik|ga,A,P
nihilista|pów,P,*nominative.pl=nihiliści,*accusative.pl=nihilistów,*vocative.pl=nihiliści
nikiel|*genitive.sg=niklu,*dative.sg=niklowi,*instrumental.sg=niklem,*locative.sg=niklu,*vocative.sg=niklu
niuton|ga
niż|pów
noc|ck
noga|*genitive.pl=nóg
nomada|pów,P,*nominative.pl=nomadzi,*accusative.pl=nomadów,*vocative.pl=nomadzi
nornica|p
norweg|ga,nowie,A,P
nos|ga
nosorożec|ga,pów,A
nosze|*genitive.sg=noszy,*dative.sg=noszom,*instrumental.sg=noszami,*locative.sg=noszach
nośnik|ga
notariusz|ga,A
notatnik|ga
notowanie|*genitive.pl=notowań
nowość|ck,ni,P
nowożeńcy|cn,A,*genitive.sg=nowożeńców,*dative.sg=nowożeńcom,*accusative.sg=nowożeńców,*instrumental.sg=nowożeńcami,*locative.sg=nowożeńcach
nowożytność|ck
nozdrze|py
nożownik|ga,A,P
nożyk|ga
nów|snowi,pów
nóż|ga
nudności|gi,A,*dative.sg=nudnościom,*instrumental.sg=nudnościami,*locative.sg=nudnościach,*vocative.sg=nudności
numerowanie|*genitive.pl=numerowań
nur|ga,A
nurek|ga,nowie,A,P
nutria|*genitive.sg=nutrii,*dative.sg=nutrii,*locative.sg=nutrii
obcas|ga
obcęgi|cn,*genitive.sg=obcęgów,*dative.sg=obcęgom,*instrumental.sg=obcęgami,*locative.sg=obcęgach
obciążenie|*genitive.pl=obciążeń
obczyzna|p
obietnica|p
objętość|ck,ni,P
oblężenie|*genitive.pl=oblężeń
obłość|ck,ni,P
oboczność|ck,ni,P
obojczyk|ga
obora|*genitive.pl=obór
obowiązek|sobowiązk
obój|pów
obrażenie|*genitive.pl=obrażeń
obrzezanie|*genitive.pl=obrzezań
obserwator|ga,A,P
obudowa|*genitive.pl=obudów
obuwik|ga
obwodnica|p
obywatel|ga,A,P,*nominative.pl=obywatele,*vocative.pl=obywatele
obywatelstwo|p
ocelot|ga,A
ocet|soct
ochroniarz|ga,A,P,*nominative.pl=ochroniarze,*vocative.pl=ochroniarze
oczęta|cn,*genitive.sg=ocząt,*dative.sg=oczętom,*instrumental.sg=oczętami,*locative.sg=oczętach
oczopląs|soczopląs
oczywistość|ck,ni,P
oda|*genitive.pl=ód
odbiornik|ga
odchody|cn,*genitive.sg=odchodów,*dative.sg=odchodom,*instrumental.sg=odchodami,*locative.sg=odchodach
odcień|ga
odcinek|ga
oddech|ny,*instrumental.sg=oddechem
odejmowanie|*genitive.pl=odejmowań
odkrycie|*genitive.pl=odkryć
odkurzacz|ga
odległość|ck,ni,P
odmowa|*genitive.pl=odmów
odporność|ck,ni,P
odpowiedź|ck,ni,P
odszkodowanie|*genitive.pl=odszkodowań
odwodnienie|*genitive.pl=odwodnień
odwrotność|ck,ni,P
ofiara|*dative.sg=ofierze,*locative.sg=ofierze
oficer|ga,A,P
ogar|ga,A
ogień|sogni,ga,pi
ogier|ga,A
ogłoszenie|*genitive.pl=ogłoszeń
ogniskowa|ne,*genitive.sg=ogniskowej,*genitive.pl=ogniskowych,*dative.sg=ogniskowej,*dative.pl=ogniskowym,*accusative.sg=ogniskową,*instrumental.pl=ogniskowymi,*locative.sg=ogniskowej,*locative.pl=ogniskowych,*vocative.sg=ogniskowa
ogon|ga
ogonek|ga
ogórek|sogórk,ga
ogr|ga,A
ogrodnik|ga,A,P
ogrodzenie|*genitive.pl=ogrodzeń
ohar|ga,A
ohm|ga
ojciec|sojc,ga,du,nowie,pów,A,P,*vocative.sg=ojcze
ojcowizna|p,*dative.sg=ojcowiznie,*locative.sg=ojcowiznie
ojczym|ga,nowie,A,P
ojczyzna|p
okaziciel|ga,A,P,*nominative.pl=okaziciele,*vocative.pl=okaziciele
okolica|p
okolicznik|ga
okoń|ga,A
okop|*vocative.sg=okopy
okostna|ne,*genitive.sg=okostnej,*genitive.pl=okostnych,*dative.sg=okostnej,*dative.pl=okostnym,*accusative.sg=okostną,*instrumental.pl=okostnymi,*locative.sg=okostnej,*locative.pl=okostnych,*vocative.sg=okostna
okrężnica|p
okrucieństwo|p
okulista|pów,P,*nominative.pl=okuliści,*accusative.pl=okulistów,*vocative.pl=okuliści
olcha|ny,*genitive.sg=olchy
olej|pów
olsza|p
ołów|*genitive.sg=ołowiu,*dative.sg=ołowiowi,*instrumental.sg=ołowiem,*locative.sg=ołowiu,*vocative.sg=ołowiu
ołówek|sołówk,ga
ołtarz|ga
om|ga
oman|*vocative.pl=omanach
onomatopeja|*genitive.sg=onomatopei,*genitive.pl=onomatopei,*dative.sg=onomatopei,*locative.sg=onomatopei
opalenizna|p
opat|ga,A,P,*nominative.pl=opaci,*vocative.pl=opaci
opiekun|ga,nowie,A,P
opiłek|ga
opinia|*genitive.sg=opinii,*genitive.pl=opinii,*dative.sg=opinii,*locative.sg=opinii
opłatek|ga
opornik|ga
opowiadanie|*genitive.pl=opowiadań
opowieść|ck,ni,P
opór|*nominative.sg=opor,*accusative.sg=opor
optyk|ga,A,P
optymista|pów,P,*nominative.pl=optymiści,*accusative.pl=optymistów,*vocative.pl=optymiści
opuchlizna|p
oracz|ga,A,P,*nominative.pl=oracze,*vocative.pl=oracze
orbitrek|sorbitrek,ga
oręż|ga
organista|pów,P,*nominative.pl=organiści,*accusative.pl=organistów,*vocative.pl=organiści
organizator|ga,A,P
organy|cn,*genitive.sg=organów,*dative.sg=organom,*instrumental.sg=organami,*locative.sg=organach
orlik|ga,A
ornitolog|ga,A,P
ornitologia|*genitive.sg=ornitologii,*dative.sg=ornitologii,*locative.sg=ornitologii
ortografia|*genitive.sg=ortografii,*dative.sg=ortografii,*locative.sg=ortografii
ortopeda|pów,P,*nominative.pl=ortopedzi,*accusative.pl=ortopedów,*vocative.pl=ortopedzi
orzech|ga,ny,A,*instrumental.sg=orzechem
orzeczenie|*genitive.pl=orzeczeń
orzecznik|ga
orzeł|sorł,ga,A
osąd|sosąd
oset|sost
osiągnięcie|*genitive.pl=osiągnięć
osiedle|pi
osioł|sosł,ga,A
oskard|ga
oskarżenie|*genitive.pl=oskarżeń
osoba|*genitive.pl=osób
osobowość|ck,ni,P
ostatek|ga
ostoja|p,*genitive.sg=ostoi,*dative.sg=ostoi,*locative.sg=ostoi
ostroga|*genitive.pl=ostróg
ostrosłup|ga
ostrość|ck,ni,P
ostrze|py
ostrzeżenie|*genitive.pl=ostrzeżeń
oszczerstwo|p
oszołom|ga,A,P,*nominative.pl=oszołomy,*vocative.pl=oszołomy
oszust|ga,A,P,*nominative.pl=oszuści,*vocative.pl=oszuści
oszustwo|p
oś|ck
oścień|ga
ość|ck,ni,P
oślę|soślęt,*genitive.sg=oślęcia,*genitive.pl=ośląt,*dative.sg=oślęciu,*instrumental.sg=oślęciem,*locative.sg=oślęciu
oślica|p
ośmiokąt|sośmiokąt,ga
ośmiornica|p
otchłań|ck
otoczak|ga
owad|ga,A
owca|*genitive.pl=owiec
owies|sows,ga
owoc|pów
ozdoba|*genitive.pl=ozdób
pacan|ga,A,P,*nominative.pl=pacany,*vocative.pl=pacany
pacha|ny,*genitive.sg=pachy
pacjent|ga,A,P,*nominative.pl=pacjenci,*vocative.pl=pacjenci
pajac|ga,pów,A
pajączek|spajączk,ga,A
pająk|spająk,ga,A
pajęczak|ga,A
pal|ga
palacz|ga,A,P,*nominative.pl=palacze,*vocative.pl=palacze
palec|ga,pów
paleontolog|ga,A,P
paleontologia|*genitive.sg=paleontologii,*dative.sg=paleontologii,*locative.sg=paleontologii
palestyńczyk|ga,A,P
pałac|pów
pamięć|ck,ni,P
pamiętnik|ga
pan|ga,du,lu,nowie,A,P,*vocative.sg=panie
pancerz|ga
pandeista|pów,P,*nominative.pl=pandeiści,*accusative.pl=pandeistów,*vocative.pl=pandeiści
pandemia|*genitive.sg=pandemii,*dative.sg=pandemii,*locative.sg=pandemii
pani|gi,di,li,*genitive.pl=pań,*accusative.sg=panią,*instrumental.sg=panią
panna|*genitive.pl=panien
panteista|pów,P,*nominative.pl=panteiści,*accusative.pl=panteistów,*vocative.pl=panteiści
papierek|ga
papieros|ga,A
papierośnica|p
papiery|cn,*genitive.sg=papierów,*dative.sg=papierom,*instrumental.sg=papierami,*locative.sg=papierach
papież|ga,A,P,*nominative.pl=papieże,*vocative.pl=papieże
paproć|ck
parafia|*genitive.sg=parafii,*dative.sg=parafii,*locative.sg=parafii
parafianin|ga,A,P
parapsychologia|*genitive.sg=parapsychologii,*dative.sg=parapsychologii,*locative.sg=parapsychologii
parasol|ga
parias|ga,ni,A,P
parlamentarzysta|pów,P,*nominative.pl=parlamentarzyści,*accusative.pl=parlamentarzystów,*vocative.pl=parlamentarzyści
parodia|*genitive.sg=parodii,*dative.sg=parodii,*locative.sg=parodii
parowiec|ga,pów
parst|ga
partacz|ga,A,P,*nominative.pl=partacze,*vocative.pl=partacze
partia|*genitive.sg=partii,*dative.sg=partii,*locative.sg=partii
partner|ga,A,P
partyzant|ga,A,P,*nominative.pl=partyzanci,*vocative.pl=partyzanci
parweniusz|ga,A,P,*nominative.pl=parweniusze,*vocative.pl=parweniusze
pary|cn,*genitive.sg=par,*dative.sg=parom,*instrumental.sg=parami,*locative.sg=parach
parzydełkowiec|ga,pów,A
pasażer|ga,nowie,A,P
pasek|ga
paser|ga,A,P
pasierb|ga,nowie,A,P
pasierbica|p
pasjans|ne
paskal|ga
pasożyt|ga,A
passat|ga,A
pasterz|ga,A,P,*nominative.pl=pasterze,*vocative.pl=pasterze
pastor|ga,A,P
pasza|p
paszcza|p
paszczur|ga,A
paszkot|ga,A
paśnik|ga
pat|ga,A
patafian|ga,A,P,*nominative.pl=patafiany,*vocative.pl=patafiany
patologia|*genitive.sg=patologii,*dative.sg=patologii,*locative.sg=patologii
patriarcha|nowie,pów,P,*genitive.sg=patriarchy,*accusative.pl=patriarchów
patyk|ga
paw|spawi,ga,le,pi,A
pawian|ga,A
paznokieć|spaznokci,ga,pi
pazur|ga
październik|ga
pączek|spączk,ga,A
pąć|spąci,gi,di,li,pi,*instrumental.sg=pącią
pąk|spąk,ga
pątnik|ga,A,P
pchła|*genitive.pl=pcheł
pecet|ga,A
pechowiec|ga,ny,pów,A,P,*vocative.sg=pechowcze
pedagog|ga,A,P
pedalarz|ga,A,P,*nominative.pl=pedalarze,*vocative.pl=pedalarze
pederasta|pów,P,*nominative.pl=pederaści,*accusative.pl=pederastów,*vocative.pl=pederaści
pediatra|pów,P,*nominative.pl=pediatrzy,*accusative.pl=pediatrów,*vocative.pl=pediatrzy
pedofil|ga,pów,A,P,*nominative.pl=pedofile,*vocative.pl=pedofile
pedryl|ga,pów,A,P,*nominative.pl=pedryle,*vocative.pl=pedryle
pelikan|ga,A
pełnoletniość|ck
penis|ga
peonia|*genitive.sg=peonii,*genitive.pl=peonii,*dative.sg=peonii,*locative.sg=peonii
pepik|ga,A,P,*nominative.pl=Pepiki,*vocative.pl=Pepiki
perfumeria|*genitive.sg=perfumerii,*dative.sg=perfumerii,*locative.sg=perfumerii
perfumy|cn,*genitive.sg=perfum,*dative.sg=perfumom,*instrumental.sg=perfumami,*locative.sg=perfumach
perkoz|ga,A
pers|ga,nowie,A,P
pestkowiec|ga,pów
pesymista|pów,P,*nominative.pl=pesymiści,*accusative.pl=pesymistów,*vocative.pl=pesymiści
pet|ga,A
petent|ga,A,P,*nominative.pl=petenci,*vocative.pl=petenci
pewnik|ga
pęknięcie|*genitive.pl=pęknięć
pępek|ga
pianista|pów,P,*nominative.pl=pianiści,*accusative.pl=pianistów,*vocative.pl=pianiści
piaskownica|p
piącha|ny,*genitive.sg=piąchy
piątek|spiątk
pieczęć|ck
pieg|ga
piekarz|ga,A,P,*nominative.pl=piekarze,*vocative.pl=piekarze
piekielnik|ga,A,P
pielęgniarz|ga,A,P,*nominative.pl=pielęgniarze,*vocative.pl=pielęgniarze
pielgrzym|ga,ni,A,P
pielucha|ny,*genitive.sg=pieluchy
pieniądz|spieniądz,ga,*genitive.pl=pieniędzy,*instrumental.pl=pieniędzmi
pień|spni,ga,pi
pierdolec|ga,pów,A
pierdoła|*genitive.pl=pierdół
pierdyliard|ga
pierdylion|ga
piernik|ga
pierogi|cn,*genitive.sg=pierogów,*dative.sg=pierogom,*instrumental.sg=pierogami,*locative.sg=pierogach
pieróg|ga
pierś|ck,ni,P
pierścienica|p
pierścień|ga
pierścionek|ga
pierwiastek|ga
pierwotniak|ga,A
pierwszak|ga,A,P,*nominative.pl=pierwszaki,*vocative.pl=pierwszaki
pierwszyzna|p
pies|sps,ga,du,A
pieseczek|ga,A
piesek|ga,A
pieśń|ck,ni,P
pięciobój|pów,*vocative.sg=pięciobój
pięciokąt|spięciokąt,ga
pięciolinia|*genitive.sg=pięciolinii,*genitive.pl=pięciolinii,*dative.sg=pięciolinii,*locative.sg=pięciolinii
piędź|ck
piękność|ck,ni,P
pięść|ck,ni,P
piętro|*genitive.pl=pięter
pigwa|p
pijak|ga,A,P
pilnik|ga
piłkarz|ga,A,P,*nominative.pl=piłkarze,*vocative.pl=piłkarze
pingwin|ga,A
piorun|ga
piosenkarz|ga,A,P,*nominative.pl=piosenkarze,*vocative.pl=piosenkarze
piórnik|ga
pirat|ga,A,P,*nominative.pl=piraci,*vocative.pl=piraci
piromania|*genitive.sg=piromanii,*dative.sg=piromanii,*locative.sg=piromanii
pisarz|ga,A,P,*nominative.pl=pisarze,*vocative.pl=pisarze
pisklę|spisklęt,*genitive.sg=pisklęcia,*genitive.pl=piskląt,*dative.sg=pisklęciu,*instrumental.sg=pisklęciem,*locative.sg=pisklęciu
piskorz|ga,A
pismak|ga,A,P,*nominative.pl=pismaki,*vocative.pl=pismaki
pismo|*locative.sg=piśmie
piszczel|ck
piwnica|p
pizza|ne,*dative.sg=pizzy,*locative.sg=pizzy
piżmaczek|ga
piżmak|ga,A
plac|pów
placek|ga
planimetria|*genitive.sg=planimetrii,*dative.sg=planimetrii,*locative.sg=planimetrii
plansza|p
plaster|splastr,ga
plastyczność|ck
plaża|p
plebania|*genitive.sg=plebanii,*genitive.pl=plebanii,*dative.sg=plebanii,*locative.sg=plebanii
plecak|ga
plemię|splemion,*genitive.sg=plemienia,*dative.sg=plemieniu,*instrumental.sg=plemieniem,*locative.sg=plemieniu
plemnik|ga
pleśń|ck
plucha|ny,*genitive.sg=pluchy
pludry|cn,*genitive.sg=pludrów,*dative.sg=pludrom,*instrumental.sg=pludrami,*locative.sg=pludrach
plus|ga
płaca|p
płacz|pów
płaszcz|ga
płaszczyzna|p
płatek|ga
płatność|ck,ni,P
płaz|ga,A
płaziniec|spłazińc,ga,pów,A
płeć|spłci,gi,di,li,pi,*instrumental.sg=płcią
płetwa|p
płetwonurek|ga,nowie,A,P
płoć|ck
płomień|ga
płótno|*genitive.pl=płócien
pływak|ga,A,P
pnącze|py
pniak|ga
pochodna|ne,*genitive.sg=pochodnej,*genitive.pl=pochodnych,*dative.sg=pochodnej,*dative.pl=pochodnym,*accusative.sg=pochodną,*instrumental.pl=pochodnymi,*locative.sg=pochodnej,*locative.pl=pochodnych,*vocative.sg=pochodna
pochodnia|*locative.sg=pochodnii
pochówek|spochówk,ga
pochwa|*genitive.pl=pochew
pochyłość|ck,ni,P
pociąg|spociąg
pociecha|ny,*genitive.sg=pociechy
początek|spoczątk
podaż|ck
podbródek|spodbródk,ga
podcast|lu,*vocative.sg=podcaście
podejrzenie|*genitive.pl=podejrzeń
podgrzybek|ga,A
podkoszulek|ga
podkowa|*genitive.pl=podków
podkreślenie|*genitive.pl=podkreśleń
podłoga|*genitive.pl=podłóg
podniebienie|*genitive.pl=podniebień
podpalacz|ga,A,P,*nominative.pl=podpalacze,*vocative.pl=podpalacze
podpalenie|*genitive.pl=podpaleń
podpowiedź|ck
podręcznik|ga
podróż|ck,spodróż
podróżnik|ga,A,P
poducha|ny,*genitive.sg=poduchy
podwieczorek|ga
podzielność|ck
poeta|pów,P,*nominative.pl=poeci,*accusative.pl=poetów,*vocative.pl=poeci
poganin|ga,A,*accusative.pl=poganie
pogoda|*genitive.pl=pogód
pojazd|*locative.sg=pojeździe,*vocative.sg=pojeździe
pojeb|ga,A,P,*nominative.pl=pojeby,*vocative.pl=pojeby
pojemnik|ga
pojęcie|*genitive.pl=pojęć
poker|ga,A
pokolenie|*genitive.pl=pokoleń
pokój|pów
polaczek|ga,A,P,*nominative.pl=polaczki,*vocative.pl=polaczki
polak|ga,A,P
pole|*genitive.pl=pól
polędwica|p
policjant|ga,A,P,*nominative.pl=policjanci,*vocative.pl=policjanci
policzek|ga
poliester|spoliestr
poligamia|*genitive.sg=poligamii,*dative.sg=poligamii,*locative.sg=poligamii
poligamista|pów,P,*nominative.pl=poligamiści,*accusative.pl=poligamistów,*vocative.pl=poligamiści
poliglota|pów,P,*nominative.pl=poligloci,*accusative.pl=poliglotów,*vocative.pl=poligloci
politeista|pów,P,*nominative.pl=politeiści,*accusative.pl=politeistów,*vocative.pl=politeiści
politolog|ga,A,P
polityk|ga,A,P
polowanie|*genitive.pl=polowań
polskość|ck
połączenie|*genitive.pl=połączeń
połowa|*genitive.pl=połów
położenie|*genitive.pl=położeń
położna|ne,*genitive.sg=położnej,*genitive.pl=położnych,*dative.sg=położnej,*dative.pl=położnym,*accusative.sg=położną,*instrumental.sg=położnej,*instrumental.pl=położnymi,*locative.sg=położnej,*locative.pl=położnych
południk|ga
południowoafrykańczyk|ga,A,P
pomarańcza|p
pomidor|ga
pomnik|ga
pomoc|ck
pomocnik|ga,A,P
pomyje|*genitive.sg=pomyj,*dative.sg=pomyjom,*instrumental.sg=pomyjami,*locative.sg=pomyjach
ponowoczesność|ck
pończochy|cn,*genitive.sg=pończoch,*dative.sg=pończochom,*instrumental.sg=pończochami,*locative.sg=pończochach
popiół|*locative.sg=popiele,*vocative.sg=popiele
popłoch|ny,*instrumental.sg=popłochem
poprawczak|ga
populista|pów,P,*nominative.pl=populiści,*accusative.pl=populistów,*vocative.pl=populiści
por|ga
pora|*genitive.pl=pór
poranek|ga
porażenie|*genitive.pl=porażeń
pornograf|ga,nowie,A,P
pornografia|*genitive.sg=pornografii,*dative.sg=pornografii,*locative.sg=pornografii
pornol|ga,A
pornos|ga,A
poronienie|*genitive.pl=poronień
porozumienie|*genitive.pl=porozumień
poroże|py
portfel|ga
portowiec|ga,ny,pów,A,P
portrecista|pów,P,*nominative.pl=portreciści,*accusative.pl=portrecistów,*vocative.pl=portreciści
portugalczyk|ga,A,P
porządek|sporządk
poseł|sposł,ga,nowie,A,P
posłaniec|sposłańc,ga,ny,pów,A,P
pośladek|ga
poświęcenie|cm,spoświęceni,ga,du,na,*genitive.pl=poświęceń
potakiwacz|ga,A,P,*nominative.pl=potakiwacze,*vocative.pl=potakiwacze
potomek|ga,nowie,A,P
potrzos|ga,A
potwarz|ck
potwór|ga,A
powiadomienie|*genitive.pl=powiadomień
powiat|*locative.sg=powiecie,*vocative.sg=powiecie
powieść|ck,ni,P
powojnik|ga
powódź|ck
powstanie|*genitive.pl=powstań
pozdrowienie|*genitive.pl=pozdrowień
poziewnik|ga
poziomica|p
półfinalista|pów,P,*nominative.pl=półfinaliści,*accusative.pl=półfinalistów,*vocative.pl=półfinaliści
półkole|pi
półksiężyc|ga,pów
półkula|p
półpasiec|*genitive.sg=półpaśca,*dative.sg=półpaścowi,*instrumental.sg=półpaścem,*locative.sg=półpaścu,*vocative.sg=półpaścu
półpiętro|*genitive.pl=półpięter
półprosta|ne,*genitive.sg=półprostej,*genitive.pl=półprostych,*dative.sg=półprostej,*dative.pl=półprostym,*accusative.sg=półprostą,*instrumental.pl=półprostymi,*locative.sg=półprostej,*locative.pl=półprostych,*vocative.sg=półprosta
półprzewodnik|ga
półrocze|py
półwysep|spółwysp
prababcia|*genitive.pl=prababć,*vocative.sg=prababciu
praca|p
pracodawca|ny,pów,P,*accusative.pl=pracodawców
pracoholik|ga,A,P
pracownik|ga,A,P
pradziadek|ga,nowie,A,P
pragnienie|*genitive.pl=pragnień
prajęzyk|ga
prałat|ga,A,P,*nominative.pl=prałaci,*vocative.pl=prałaci
praporządek|spraporządk
prawiczek|ga,nowie,A,P
prawnik|ga,A,P
prawnuczek|ga,nowie,A,P
prawnuk|ga,nowie,A,P
prącie|*genitive.pl=prąć
prąd|sprąd
precel|sprecl,ga
premier|ga,A,P
pretor|ga,A,P
prezes|ga,ni,A,P
prezydent|ga,A,P,*nominative.pl=prezydenci,*vocative.pl=prezydenci
pręcik|ga
prędkościomierz|ga
prędkość|ck,ni,P
pręt|ga
priv|ga,*locative.sg=privie,*vocative.sg=privie
proca|p
procesor|ga
proch|ny,*instrumental.sg=prochem
proepidemik|ga,A,P
profes|ga,ni,A,P
profesor|ga,nowie,A,P
programista|pów,P,*nominative.pl=programiści,*accusative.pl=programistów,*vocative.pl=programiści
programowanie|*genitive.pl=programowań
projektant|ga,A,P,*nominative.pl=projektanci,*vocative.pl=projektanci
prokurator|ga,A,P
promień|ga
prominent|ga,A,P,*nominative.pl=prominenci,*instrumental.sg=prominencie,*instrumental.pl=prominentach,*locative.sg=prominentem,*locative.pl=prominentami,*vocative.pl=prominenci
proporzec|sproporc,ga,pów
proroctwo|p
prorok|ga,A,P
prosiak|ga,A
prosię|sprosięt,*genitive.sg=prosięcia,*genitive.pl=prosiąt,*dative.sg=prosięciu,*instrumental.sg=prosięciem,*locative.sg=prosięciu
prosta|ne,*genitive.sg=prostej,*genitive.pl=prostych,*dative.sg=prostej,*dative.pl=prostym,*accusative.sg=prostą,*instrumental.pl=prostymi,*locative.sg=prostej,*locative.pl=prostych,*vocative.sg=prosta
prostokąt|sprostokąt,ga
prośba|*genitive.pl=próśb
prozodia|*genitive.sg=prozodii,*dative.sg=prozodii,*locative.sg=prozodii
prusak|ga,A
prysznic|ga,pów
prywaciarz|ga,A,P,*nominative.pl=prywaciarze,*vocative.pl=prywaciarze
przechodzień|sprzechodni,ga,pów,A,P,*nominative.pl=przechodnie,*vocative.pl=przechodnie
przeciąg|sprzeciąg
przecinek|ga
przeciwnik|ga,A,P
przedimek|ga
przedmieście|*genitive.pl=przedmieść
przedmowa|*genitive.pl=przedmów
przedmówca|ny,pów,P,*accusative.pl=przedmówców
przedramię|sprzedramion,*genitive.sg=przedramienia,*dative.sg=przedramieniu,*instrumental.sg=przedramieniem,*locative.sg=przedramieniu
przedrostek|ga
przedsiębiorca|ny,pów,P,*accusative.pl=przedsiębiorców
przedsiębiorstwo|p
przedsięwzięcie|*genitive.pl=przedsięwzięć
przedsionek|ga
przedstawienie|*genitive.pl=przedstawień
przedszkole|pi
przegląd|sprzegląd
przejście|*genitive.pl=przejść
przekaźnik|ga
przekątna|ne,*genitive.sg=przekątnej,*genitive.pl=przekątnych,*dative.sg=przekątnej,*dative.pl=przekątnym,*accusative.sg=przekątną,*instrumental.pl=przekątnymi,*locative.sg=przekątnej,*locative.pl=przekątnych,*vocative.sg=przekątna
przekleństwo|lu,p
przekłamanie|*genitive.pl=przekłamań
przekonanie|*genitive.pl=przekonań
przekrój|pów
przełącznik|ga
przełęcz|ck
przemówienie|*genitive.pl=przemówień
przemytnik|ga,A,P
przepaść|ck
przerwa|p
przesłuchanie|*genitive.pl=przesłuchań
przestępca|ny,pów,P,*accusative.pl=przestępców
przestępczość|ck,ni,P
przestępstwo|p
przestrzeń|ck
przeszkoda|*genitive.pl=przeszkód
przetacznik|ga
przewodniczący|cn,ny,A,P,*genitive.sg=przewodniczącego,*genitive.pl=przewodniczących,*dative.sg=przewodniczącemu,*dative.pl=przewodniczącym,*accusative.sg=przewodniczącego,*accusative.pl=przewodniczących,*instrumental.sg=przewodniczącym,*instrumental.pl=przewodniczącymi,*locative.sg=przewodniczącym,*locative.pl=przewodniczących
przeziębienie|*genitive.pl=przeziębień
przeżuwacz|ga,A
przędza|p
przodkini|cf,sprzodkini,*genitive.pl=przodkiń,*vocative.sg=przodkini
przybysz|ga,A,P,*nominative.pl=przybysze,*vocative.pl=przybysze
przydomek|ga
przydupas|ga,ni,A,P
przygoda|*genitive.pl=przygód
przyimek|ga
przyjaciel|ga,A,P,*nominative.pl=przyjaciele,*genitive.pl=przyjaciół,*dative.pl=przyjaciołom,*accusative.pl=przyjaciół,*instrumental.pl=przyjaciółmi,*locative.pl=przyjaciołach,*vocative.pl=przyjaciele
przyjaźń|ck
przyjemność|ck,ni,P
przyjęcie|*genitive.pl=przyjęć
przymiotnik|ga
przypadłość|ck,ni,P
przypowieść|ck,ni,P
przyrostek|ga
przyrząd|sprzyrząd
przysięga|*genitive.pl=przysiąg
przysłowie|*genitive.pl=przysłów
przysłówek|sprzysłówk,ga
przyspieszenie|*genitive.pl=przyspieszeń
przywódca|ny,pów,P,*accusative.pl=przywódców
przyzwoitość|ck
przyzwolenie|*genitive.pl=przyzwoleń
psałterz|ga
pstrąg|spstrąg,ga,A
psy|cn,*genitive.sg=psów,*dative.sg=psom,*instrumental.sg=psami,*locative.sg=psach
psychiatra|pów,P,*nominative.pl=psychiatrzy,*accusative.pl=psychiatrów,*vocative.pl=psychiatrzy
psychiatryk|ga
psychol|ga,A
psycholog|ga,A,P
psychologia|*genitive.sg=psychologii,*dative.sg=psychologii,*locative.sg=psychologii
psychoterapeuta|pów,P,*nominative.pl=psychoterapeuci,*accusative.pl=psychoterapeutów,*vocative.pl=psychoterapeuci
pszczelarz|ga,A,P,*nominative.pl=pszczelarze,*vocative.pl=pszczelarze
pszczoła|*genitive.pl=pszczół
pszeniec|spszeńc,ga,pów
ptak|ga,A
ptaszek|ga,A
puch|*instrumental.sg=puchem
puchacz|ga,A
pudel|spudl,ga,A
pulmonolog|ga,A,P
pulpet|ga
pulsar|ga
pułkownik|ga,A,P
puryfikaterz|ga
purysta|pów,P,*nominative.pl=puryści,*accusative.pl=purystów,*vocative.pl=puryści
pustak|ga
pustelnik|ga,A,P
pustynia|*genitive.pl=pustyń
puszczyk|ga,A
pylnik|ga
pysk|ga
pytajnik|ga
pytanie|*genitive.pl=pytań
pyton|ga,A
rabin|ga,ni,A,P
rachunkowość|ck
racica|p
radian|ga
radioaktywność|ck
radioamator|ga,A,P
radioastronomia|*genitive.sg=radioastronomii,*dative.sg=radioastronomii,*locative.sg=radioastronomii
radiobusola|p
radiochemia|*genitive.sg=radiochemii,*dative.sg=radiochemii,*locative.sg=radiochemii
radiografia|*genitive.sg=radiografii,*dative.sg=radiografii,*locative.sg=radiografii
radiokomunikacja|*instrumental.sg=radiokomunikacja
radiolog|ga,A,P
radiologia|*genitive.sg=radiologii,*dative.sg=radiologii,*locative.sg=radiologii
radiomonter|ga,A,P
radna|ne,*genitive.sg=radnej,*genitive.pl=radnych,*dative.sg=radnej,*dative.pl=radnym,*accusative.sg=radną,*instrumental.pl=radnymi,*locative.sg=radnej,*locative.pl=radnych,*vocative.sg=radna
radny|cn,ni,A,P,*genitive.sg=radnego,*genitive.pl=radnych,*dative.sg=radnemu,*dative.pl=radnym,*accusative.sg=radnego,*accusative.pl=radnych,*instrumental.sg=radnym,*instrumental.pl=radnymi,*locative.sg=radnym,*locative.pl=radnych
radość|ck,ni,P
rajdowiec|ga,ny,pów,A,P
rajtuzy|cn,*genitive.sg=rajtuzów,*dative.sg=rajtuzom,*instrumental.sg=rajtuzami,*locative.sg=rajtuzach
rak|ga,A
ramię|sramion,*genitive.sg=ramienia,*dative.sg=ramieniu,*instrumental.sg=ramieniem,*locative.sg=ramieniu
ramol|ga,A,P,*nominative.pl=ramole,*vocative.pl=ramole
rasista|pów,P,*nominative.pl=rasiści,*accusative.pl=rasistów,*vocative.pl=rasiści
rataj|ga,pów,A,P,*nominative.pl=rataje,*vocative.pl=rataje
ratownik|ga,A,P
rdzeń|ga
reaktor|ga
realista|pów,P,*nominative.pl=realiści,*accusative.pl=realistów,*vocative.pl=realiści
reformator|ga,A,P
rekin|ga,A
rektor|ga,A,P
religia|*genitive.sg=religii,*dative.sg=religii,*locative.sg=religii
relikwiarz|ga
remake|cm,sremake',lu,*nominative.pl=remaki,*genitive.sg=remak'u,*dative.sg=remak'owi,*accusative.pl=remaki,*instrumental.sg=remakiem,*vocative.pl=remaki
renegat|ga,A,P,*nominative.pl=renegaci,*vocative.pl=renegaci
renifer|ga,A
rentgen|ga
reprezentant|ga,A,P,*nominative.pl=reprezentanci,*vocative.pl=reprezentanci
rezun|ga,ni,A,P
rezus|ga,A
reżyser|ga,A,P
ręcznik|ga
rękaw|ga
rękawica|p
rękoczyny|cn,*genitive.sg=rękoczynów,*dative.sg=rękoczynom,*instrumental.sg=rękoczynami,*locative.sg=rękoczynach
rękojeść|ck,ni,P
robak|ga,A
robinia|*genitive.sg=robinii,*genitive.pl=robinii,*dative.sg=robinii,*locative.sg=robinii
robocizna|p
robot|ga,A
robota|*genitive.pl=robót
robotnik|ga,A,P
rocznica|p
rodak|ga,A,P
rodzaj|pów
rodzajnik|ga
rodzic|ga,pów,A,P,*nominative.pl=rodzice,*vocative.pl=rodzice
rodzynek|ga
rogal|ga
rogalik|ga
rolnik|ga,A,P
ropucha|ny,*genitive.sg=ropuchy
rosjanin|ga,A,P
rosomak|ga,A
roślinożerca|ny,pów,P,*accusative.pl=roślinożerców
rotor|ga
rowerzysta|pów,P,*nominative.pl=rowerzyści,*accusative.pl=rowerzystów,*vocative.pl=rowerzyści
rozbieżność|ck,ni,P
rozbitek|ga,nowie,A,P
rozchodniak|ga,A
rozczarowanie|*genitive.pl=rozczarowań
rozgałęźnik|ga
rozgwiazda|*dative.sg=rozgwieździe,*locative.sg=rozgwieździe
rozkład|lu
rozkosz|ck
rozmaitość|ck,ni,P
rozmowa|*genitive.pl=rozmów
rozpacz|ck
rozpaczanie|*genitive.pl=rozpaczań
rozpierducha|ny,*genitive.sg=rozpierduchy
rozpuszczalnik|ga
rozruch|ny,*instrumental.sg=rozruchem
rozrusznik|ga
rozsądek|srozsądk
rozstaj|pów
rozstrój|pów
rozszczepienie|*genitive.pl=rozszczepień
rozum|cm
rozważanie|*genitive.pl=rozważań
rozwiązanie|*genitive.pl=rozwiązań
rozwidlenie|*genitive.pl=rozwidleń
rożeniec|srożeńc,ga,pów,A
rój|pów
rówieśnik|ga,A,P
równanie|*genitive.pl=równań
równoleżnik|ga
równonoc|ck
równość|ck,ni,P
równoważnik|ga
róż|sróż
róża|p
różaniec|sróżańc,ga,pów
różnica|p
różniczkowanie|*genitive.pl=różniczkowań
rtęć|ck
rubel|srubl,ga,A
ruch|ny,*instrumental.sg=ruchem
ruczaj|pów
rudzik|ga,A
ruja|*genitive.sg=rui,*genitive.pl=rui,*dative.sg=rui,*locative.sg=rui
rum|cm
rumak|ga,A
rurociąg|srurociąg
rusek|ga,ne,A,P
rybak|ga,A,P
rybałt|ga,A,P,*nominative.pl=rybałci,*vocative.pl=rybałci
rybitwa|p
rybołów|ga,A
rycerz|ga,A,P,*nominative.pl=rycerze,*vocative.pl=rycerze
rydel|srydl,ga
rydz|ga,pów,A
ryj|ga,pów
rylec|ga,pów
rysik|ga
ryś|ga,A
rzecz|ck,ny,P
rzecznik|ga,A,P
rzeczownik|ga
rzeczoznawca|ny,pów,P,*accusative.pl=rzeczoznawców
rzeczywistość|ck,ni,P
rzemień|ga
rzemieślnik|ga,A,P
rzemiosło|p
rzesza|p
rzeź|ck
rzeźbiarz|ga,A,P,*nominative.pl=rzeźbiarze,*vocative.pl=rzeźbiarze
rzeźnik|ga,A,P
rzeżucha|ny,*genitive.sg=rzeżuchy
rzodkiew|srzodkwi,gi,di,li,pi,*instrumental.sg=rzodkwią
rzutki|cn,*genitive.sg=rzutek,*dative.sg=rzutkom,*instrumental.sg=rzutkami,*locative.sg=rzutkach
rzutnik|ga
rzygacz|ga
rzymianin|ga,A,P
sadownik|ga,A,P
sadza|py
sadziec|ssadźc,ga,pów
saksofonista|pów,P,*nominative.pl=saksofoniści,*accusative.pl=saksofonistów,*vocative.pl=saksofoniści
salamandra|*genitive.pl=salamander
samica|p
samiec|ga,pów,A
samobójca|ny,pów,P,*accusative.pl=samobójców
samobójstwo|p
samotnik|ga,A,P
samotność|ck
samouk|ga,A,P,*nominative.pl=samouki,*vocative.pl=samouki
samuraj|ga,nowie,pów,A,P,*vocative.pl=samuraje
sandacz|ga,A
saneczkarz|ga,A,P,*nominative.pl=saneczkarze,*vocative.pl=saneczkarze
sanitariusz|ga,A,P,*nominative.pl=sanitariusze,*vocative.pl=sanitariusze
saracen|ga,ni,A,P
satanista|pów,P,*nominative.pl=sataniści,*accusative.pl=satanistów,*vocative.pl=sataniści
satrapa|nowie,pów,P,*accusative.pl=satrapów
satrapia|*genitive.sg=satrapii,*dative.sg=satrapii,*locative.sg=satrapii
sąd|ssąd
sąg|ssąg,ga
sąsiad|ga,A,P,*nominative.pl=sąsiedzi,*locative.sg=sąsiedzie,*vocative.sg=sąsiedzie,*vocative.pl=sąsiędzi
scenariusz|ga
scenarzysta|pów,P,*nominative.pl=scenarzyści,*accusative.pl=scenarzystów,*vocative.pl=scenarzyści
sceptyk|ga,A,P
schizofrenia|*genitive.sg=schizofrenii,*dative.sg=schizofrenii,*locative.sg=schizofrenii
schizofrenik|ga,A,P
schorzenie|*genitive.pl=schorzeń
schowek|ga
schronienie|*genitive.pl=schronień
scyzoryk|ga
seksualność|ck
seksuologia|*genitive.sg=seksuologii,*dative.sg=seksuologii,*locative.sg=seksuologii
seler|ga
seminarzysta|pów,P,*nominative.pl=seminarzyści,*accusative.pl=seminarzystów,*vocative.pl=seminarzyści
senior|ga,A,P
ser|ga
serb|ga,nowie,A,P
serce|p
sernik|ga
serwer|ga
set|ga
sęp|ga,A
sfinks|ga,A
shogun|ga,ni,A
sianokosy|cn,*genitive.sg=sianokosów,*dative.sg=sianokosom,*instrumental.sg=sianokosami,*locative.sg=sianokosach
sieć|ck,ni,P
siedmiokąt|ssiedmiokąt,ga
siedzenie|*genitive.pl=siedzeń
siekacz|ga
siemens|ga
siemię|ssiemion,*genitive.sg=siemienia,*dative.sg=siemieniu,*instrumental.sg=siemieniem,*locative.sg=siemieniu
sierp|ga
sierpień|ssierpni,ga,pi
sierść|ck,ni,P
siewca|ny,pów,P,*accusative.pl=siewców
siewnik|ga
silnik|ga
simens|ga
siniak|ga
sinologia|*genitive.sg=sinologii,*dative.sg=sinologii,*locative.sg=sinologii
sinus|ga
siogun|ga,ni,A
siostra|*genitive.pl=sióstr
siostrzenica|p
siostrzeniec|ssiostrzeńc,ga,ny,pów,A,P
siusiak|ga
siwert|ga
skala|p
skalnica|p
skalpel|ga
skamieniałość|ck,ni,P
skarbiec|ga,pów
skarbnica|p
skazaniec|sskazańc,ga,ny,pów,A,P
skąpiec|sskąpc,ga,ny,pów,A,P
składnik|ga
skłonność|ck,ni,P
skorpion|ga,A
skorupiak|ga,A
skowronek|ga,A
skrobia|pi
skroń|ck
skrót|sskrót
skrótowiec|ga,pów
skrzat|ga,A
skrzydłorzech|ga,ny,*instrumental.sg=skrzydłorzechem
skrzynia|*genitive.pl=skrzyń
skrzypce|*genitive.sg=skrzypiec,*dative.sg=skrzypcom,*instrumental.sg=skrzypcami,*locative.sg=skrzypcach
skrzypek|ga,nowie,A,P
skrzyżowanie|*genitive.pl=skrzyżowań
skunks|ga,A
skurwysyn|ga,lu,A,P,*nominative.pl=skurwysyny,*vocative.pl=skurwysyny
skuter|ga
slawista|pów,P,*nominative.pl=slawiści,*accusative.pl=slawistów,*vocative.pl=slawiści
slipy|cn,*genitive.sg=slipów,*dative.sg=slipom,*instrumental.sg=slipami,*locative.sg=slipach
słabość|ck,ni,P
słodycze|*genitive.sg=słodyczy,*dative.sg=słodyczom,*instrumental.sg=słodyczami,*locative.sg=słodyczach
słoiczek|ga
słonecznik|ga
słonica|p
słoń|ga,A
słońce|p
słowak|ga,A,P
słoweniec|sSłoweńc,ga,ny,pów,A,P
słowianin|ga,A,P
słowik|ga,A
słownik|ga
słój|ga,pów
słuch|*instrumental.sg=słuchem
słuchawki|cn,*genitive.sg=słuchawek,*dative.sg=słuchawkom,*instrumental.sg=słuchawkami,*locative.sg=słuchawkach
sługa|pów,P,*nominative.pl=słudzy,*accusative.pl=sługów,*vocative.pl=słudzy
sługus|ga,ni,A,P
słupek|ga
służąca|*genitive.sg=służącej,*genitive.pl=służących,*dative.sg=służącej,*dative.pl=służącym,*accusative.sg=służącą,*instrumental.pl=służącymi,*locative.sg=służącej,*locative.pl=służących,*vocative.sg=służąca
smerf|ga,A
smok|ga,A
smoła|*genitive.pl=smół
smycz|ck
smyk|ga,A,P,*nominative.pl=smyki,*vocative.pl=smyki
snooker|ga
snycerz|ga,A,P,*nominative.pl=snycerze,*vocative.pl=snycerze
sobota|*genitive.pl=sobót
sobowtór|ssobowtór,ga,A,P,*nominative.pl=sobowtóry,*vocative.pl=sobowtóry
soból|ga,A
socha|ny,*genitive.sg=sochy
socjalista|pów,P,*nominative.pl=socjaliści,*accusative.pl=socjalistów,*vocative.pl=socjaliści
socjologia|*genitive.sg=socjologii,*dative.sg=socjologii,*locative.sg=socjologii
socynianin|ga,A,P
soczewica|p
sodomita|pów,P,*nominative.pl=sodomici,*accusative.pl=sodomitów,*vocative.pl=sodomici
sokół|ga,A
sołectwo|p
sopel|ssopl,ga
soul|cn,A,*genitive.sg=soul,*dative.sg=soul,*instrumental.sg=soul,*locative.sg=soul
sowa|*genitive.pl=sów
sól|ck
spacerniak|ga
spawacz|ga,A,P,*nominative.pl=spawacze,*vocative.pl=spawacze
spekulant|ga,A,P,*nominative.pl=spekulanci,*vocative.pl=spekulanci
spichlerz|ga
spięcie|*genitive.pl=spięć
spirodela|p
spodek|ga
spodenki|cn,*genitive.sg=spodenek,*dative.sg=spodenkom,*instrumental.sg=spodenkami,*locative.sg=spodenkach
spojrzenie|*genitive.pl=spojrzeń
społeczeństwo|p
sportowiec|ga,ny,pów,A,P
spotkanie|*genitive.pl=spotkań
spowiednik|ga,A,P
spowiedź|ck,ni,P
spódnica|p
spójnik|ga
sprzątacz|ga,A,P,*nominative.pl=sprzątacze,*vocative.pl=sprzątacze
sprzeczka|*genitive.pl=szprzeczek
sprzedawca|ny,pów,P,*accusative.pl=sprzedawców
sprzedawczyni|cf,ssprzedawczyni,*genitive.pl=sprzedawczyń,*vocative.sg=sprzedawczyni
sprzedaż|ck
sracz|ga
ssak|ga,A
stal|ck
stała|ne,*genitive.sg=stałej,*genitive.pl=stałych,*dative.sg=stałej,*dative.pl=stałym,*accusative.sg=stałą,*instrumental.pl=stałymi,*locative.sg=stałej,*locative.pl=stałych,*vocative.sg=stała
stanik|ga
starość|ck
starzec|sstarc,ga,ny,pów,A,P,*vocative.sg=starcze
statua|cm,sstatu,gi,di,li,pi,*accusative.sg=statuę,*instrumental.sg=statuą,*vocative.sg=statuo
statysta|pów,P,*nominative.pl=statyści,*accusative.pl=statystów,*vocative.pl=statyści
statystyk|ga,A,P
stawonóg|ga,A
stągiew|sstągwi,gi,di,li,pi,*instrumental.sg=stągwią
stechiometria|*genitive.sg=stechiometrii,*dative.sg=stechiometrii,*locative.sg=stechiometrii
steganografia|*genitive.sg=steganografii,*dative.sg=steganografii,*locative.sg=steganografii
steradian|ga
stereometria|*genitive.sg=stereometrii,*dative.sg=stereometrii,*locative.sg=stereometrii
sterowiec|ga,pów
sterownik|ga
stęp|ga
stodoła|*genitive.pl=stodół
stoisko|p
stojan|ga
stolarz|ga,A,P,*nominative.pl=stolarze,*vocative.pl=stolarze
stolica|p
stoliczek|ga
stolik|ga
stomatolog|ga,A,P
stonoga|*genitive.pl=stonóg
stopa|*genitive.pl=stóp
stopień|sstopni,ga,pi
storczyk|ga
stożek|ga
strach|ny,*instrumental.sg=strachem
strateg|ga,A,P
strategia|*genitive.sg=strategii,*dative.sg=strategii,*locative.sg=strategii
straż|ck
strażak|ga,A,P
strażnik|ga,A,P
strąk|sstrąk,ga
strit|ga
stroik|ga
strój|pów
stróż|sstróż,ga,nowie,A,P
strug|ga
strumień|ga
strup|ga
struś|ga,A
strych|ny,*instrumental.sg=strychem
stryj|ga,nowie,pów,A,P
stryjek|ga,nowie,A,P
strzecha|ny,*genitive.sg=strzechy
strzelanie|*genitive.pl=strzelań
strzelec|ga,ny,pów,A,P
strzemienny|cn,ne,A,*genitive.sg=strzemiennego,*genitive.pl=strzemiennych,*dative.sg=strzemiennemu,*dative.pl=strzemiennym,*accusative.sg=strzemiennego,*instrumental.sg=strzemiennym,*instrumental.pl=strzemiennymi,*locative.sg=strzemiennym,*locative.pl=strzemiennych
strzemię|sstrzemion,*genitive.sg=strzemienia,*dative.sg=strzemieniu,*instrumental.sg=strzemieniem,*locative.sg=strzemieniu
strzykwa|p
strzyżyk|ga,A
student|ga,A,P,*nominative.pl=studenci,*vocative.pl=studenci
stulatek|ga,nowie,A,P
stułbia|pi
stwierdzenie|*genitive.pl=stwierdzeń
stwór|ga,A
styczeń|sstyczni,ga,pów
styczna|ne,*genitive.sg=stycznej,*genitive.pl=stycznych,*dative.sg=stycznej,*dative.pl=stycznym,*accusative.sg=styczną,*instrumental.pl=stycznymi,*locative.sg=stycznej,*locative.pl=stycznych,*vocative.sg=styczna
styl|pów
sucz|ck
sufler|ga,A,P
sukinsyn|ga,ni,A,P
sułtan|ga,nowie,A,P
sum|cm,ga,A
sumienie|cm,ssumieni,ga,du,na,*genitive.pl=sumień
supeł|ssupł,ga
superkomputer|ga
supernowa|ne,*genitive.sg=supernowej,*genitive.pl=supernowych,*dative.sg=supernowej,*dative.pl=supernowym,*accusative.sg=supernową,*instrumental.pl=supernowymi,*locative.sg=supernowej,*locative.pl=supernowych,*vocative.sg=supernowa
surowiec|ga,pów
surrealista|pów,P,*nominative.pl=surrealiści,*accusative.pl=surrealistów,*vocative.pl=surrealiści
suseł|ssusł,ga,A
susza|p
sutanna|p
sutener|ga,A,P
swat|ga,nowie,A,P
sweter|sswetr,ga
swoboda|*genitive.pl=swobód
sylwester|ssylwestr,ga,A
symfonia|*genitive.sg=symfonii,*genitive.pl=symfonii,*dative.sg=symfonii,*locative.sg=symfonii
sympatia|*genitive.sg=sympatii,*dative.sg=sympatii,*locative.sg=sympatii
syn|ga,lu,nowie,A,P
syndykalista|pów,P,*nominative.pl=syndykaliści,*accusative.pl=syndykalistów,*vocative.pl=syndykaliści
synowa|ne,*genitive.sg=synowej,*genitive.pl=synowych,*dative.sg=synowej,*dative.pl=synowym,*accusative.sg=synową,*instrumental.pl=synowymi,*locative.sg=synowej,*locative.pl=synowych
szabla|*genitive.pl=szabel
szablodziób|ga,A
szabrownik|ga,A,P
szachista|pów,P,*nominative.pl=szachiści,*accusative.pl=szachistów,*vocative.pl=szachiści
szachownica|p
szakal|ga,A
szal|ga
szaleniec|sszaleńc,ga,ny,pów,A,P,*vocative.sg=szaleńcze
szaleństwo|p,*vocative.pl=szleństwa
szalik|ga
szałamaja|p,*genitive.sg=szałamai,*dative.sg=szałamai,*locative.sg=szałamai
szałwia|*genitive.sg=szałwii,*dative.sg=szałwii,*locative.sg=szałwii
szaman|ga,ni,A,P
szambo|*genitive.pl=szameb
szantażysta|pów,P,*nominative.pl=szantażyści,*accusative.pl=szantażystów,*vocative.pl=szantażyści
szarańcza|py
szarawary|cn,*genitive.sg=szarawarów,*dative.sg=szarawarom,*instrumental.sg=szarawarami,*locative.sg=szarawarach
szarlatan|ga,ni,A,P
szarość|ck,ni,P
szaszłyk|ga
szczegół|sszczegół
szczenię|sszczenięt,*genitive.sg=szczenięcia,*genitive.pl=szczeniąt,*dative.sg=szczenięciu,*instrumental.sg=szczenięciem,*locative.sg=szczenięciu
szczepienie|*genitive.pl=szczepień
szczerość|ck
szczudłak|ga,A
szczupak|ga,A
szczur|ga,A
szczurzyca|p
szczygieł|sszczygł,ga,A
szczypiorniak|ga,A
szczypiornista|pów,P,*nominative.pl=szczypiorniści,*accusative.pl=szczypiornistów,*vocative.pl=szczypiorniści
szef|ga,nowie,A,P
szelężnik|ga
szelki|cn,*genitive.sg=szelek,*dative.sg=szelkom,*instrumental.sg=szelkami,*locative.sg=szelkach
szerokość|ck,ni,P
szerszeń|ga,A
sześciokąt|ssześciokąt,ga
sześćdziesięciolatek|ga,nowie,A,P
szew|sszw
szewc|ga,ny,pów,A,P,*vocative.sg=szewcze
szkic|pów
szkocka|ne,*genitive.sg=szkockiej,*genitive.pl=szkockich,*dative.sg=szkockiej,*dative.pl=szkockim,*accusative.sg=szkocką,*instrumental.pl=szkockimi,*locative.sg=szkockiej,*locative.pl=szkockich,*vocative.sg=szkocka
szkodnik|ga,A
szkoła|*genitive.pl=szkół
szkop|ga,A
szkot|ga,A,P,*nominative.pl=Szkoci,*vocative.pl=Szkoci
szkuner|ga
szkutnik|ga,A,P
szlachar|ga,A
szlachcic|ga,pów,A,P,*nominative.pl=szlachcice,*vocative.pl=szlachcice
szlafrok|ga
szlauch|ga,ny,*instrumental.sg=szlauchem
szlug|ga,A
szmalcownik|ga,A,P
szmugler|ga,A,P
sznur|ga
sznurek|ga
szogun|ga,ni,A
szop|ga,A
szpadel|sszpadl,ga
szpak|ga,A
szparag|ga,A
szpieg|ga,A,P
szpital|ga
szpon|ga
szprot|ga,A
szprycha|ny,*genitive.sg=szprychy
szpula|p
szubienica|p
szuler|ga,A,P
szum|cm
szwab|ga,A,P,*nominative.pl=szwaby,*vocative.pl=szwaby
szwagier|sszwagr,ga,nowie,A,P
szwajcar|ga,A,P
szwajcar|ga,A,P
szwed|ga,A,P,*nominative.pl=Szwedzi,*vocative.pl=Szwedzi
szyberdach|ny,*instrumental.sg=szyberdachem
szybkość|ck,ni,P
szybowiec|ga,pów
szyfrowanie|*genitive.pl=szyfrowań
szyja|p,*genitive.sg=szyi,*dative.sg=szyi,*locative.sg=szyi
szympans|ga,A
ściernisko|p,*instrumental.sg=ścierniskem
śledziennica|p
ślepiec|ga,ny,pów,A,P
ślimacznica|p
ślimak|ga,A
ślusarz|ga,A,P,*nominative.pl=ślusarze,*vocative.pl=ślusarze
śluzowiec|ga,pów,A
śmiech|ny,*instrumental.sg=śmiechem
śmieci|gi,A,*dative.sg=śmieciom,*instrumental.sg=śmieciami,*locative.sg=śmieciach,*vocative.sg=śmieci
śmieciarz|ga,A,P,*nominative.pl=śmieciarze,*vocative.pl=śmieciarze
śmierć|ck,ni,P
śmiertelnik|ga,A,P
śmietnik|ga
śmigłowiec|ga,pów,*nominative.sg=świgłowiec,*accusative.sg=świgłowiec
śniadanie|*genitive.pl=śniadań
śnieżyca|p
śpiewak|ga,A,P
śpioch|ga,ny,A,P,*instrumental.sg=śpiochem
śpiwór|ga
średnia|*genitive.sg=średniej,*genitive.pl=średnich,*dative.sg=średniej,*dative.pl=średnim,*accusative.sg=średnią,*instrumental.pl=średnimi,*locative.sg=średniej,*locative.pl=średnich,*vocative.sg=średnia
średnica|p
średnik|ga
środa|*genitive.pl=śród
środek|ga
środki|cn,*genitive.sg=środków,*dative.sg=środkom,*instrumental.sg=środkami,*locative.sg=środkach
śródrostek|ga,*nominative.sg=środrostek,*accusative.sg=środrostek
świadek|ga,nowie,A,P
świadomość|ck,ni,P
świat|ga,du,*locative.sg=świecie,*vocative.sg=świecie
światła|cn,*genitive.sg=świateł,*dative.sg=światłom,*instrumental.sg=światłami,*locative.sg=światłach
światło|*locative.sg=świetle
światłość|ck,ni,P
świątynia|*genitive.pl=świątyń
świder|sświdr,ga
świeca|p
świecznik|ga
świerk|ga
świerszcz|ga,A
świerszczyk|ga,A
świetność|ck
święto|*genitive.pl=świąt
świnia|*genitive.pl=świń
świniopas|ga,A
świr|ga,A,P,*nominative.pl=świry,*vocative.pl=świry
świstak|ga,A
świstun|ga,A
tabela|p
tablica|p
taca|p
tajemnica|p
taksówkarz|ga,A,P,*nominative.pl=taksówkarze,*vocative.pl=taksówkarze
talerz|ga
talia|*genitive.sg=talii,*genitive.pl=talii,*dative.sg=talii,*locative.sg=talii
tancerz|ga,A,P,*nominative.pl=tancerze,*vocative.pl=tancerze
tangens|ga
taniec|stańc,ga,pów
taniocha|*genitive.sg=taniochy
tankowiec|ga,pów
tapir|ga,A
tarcza|p
tarczyca|p
tasak|ga
tasza|p
tasznik|ga
tata|nowie,pów,P,*accusative.pl=tatów
tatar|ga
taternik|ga,A,P
tato|cf,nowie,pów,P,*accusative.pl=tatów
tatuś|ga,nowie,pów,A,P
tautologia|*genitive.sg=tautologii,*dative.sg=tautologii,*locative.sg=tautologii
tchawica|p
technik|ga,A,P
teista|pów,P,*nominative.pl=teiści,*accusative.pl=teistów,*vocative.pl=teiści
tekściarz|ga,A,P,*nominative.pl=tekściarze,*vocative.pl=tekściarze
telenowela|p
teleturniej|pów
telewizor|ga
temblak|ga
tender|stendr,ga
tenis|ga,A
tenisista|pów,P,*nominative.pl=tenisiści,*accusative.pl=tenisistów,*vocative.pl=tenisiści
tensor|ga
teoria|*genitive.sg=teorii,*dative.sg=teorii,*locative.sg=teorii
terapeuta|pów,P,*nominative.pl=terapeuci,*accusative.pl=terapeutów,*vocative.pl=terapeuci
terapia|*genitive.sg=terapii,*dative.sg=terapii,*locative.sg=terapii
terminator|ga,P,*accusative.sg=terminator
terrorysta|pów,P,*nominative.pl=terroryści,*accusative.pl=terrorystów,*vocative.pl=terroryści
teściowa|ne,*genitive.sg=teściowej,*genitive.pl=teściowych,*dative.sg=teściowej,*dative.pl=teściowym,*accusative.sg=teściową,*instrumental.pl=teściowymi,*locative.sg=teściowej,*locative.pl=teściowych
teść|ga,nowie,pów,A,P
tęcza|p
tętnica|p
tężec|ga
tir|ga,A
tkacz|ga,A,P,*nominative.pl=tkacze,*vocative.pl=tkacze
tłum|cm
tłumacz|ga,A,P,*nominative.pl=tłumacze,*vocative.pl=tłumacze
tłumaczenie|*genitive.pl=tłumaczeń
tłuszcz|pów
tokarz|ga,A,P,*nominative.pl=tokarze,*vocative.pl=tokarze
topnik|ga
topograf|ga,nowie,A,P
topola|*genitive.pl=topól
topór|ga
torba|*genitive.pl=toreb
torbacz|ga,A
torcik|ga
tornister|stornistr,ga
tost|ga
toster|ga
tożsamość|ck,ni,P
traganek|ga
tragarz|ga,A,P,*nominative.pl=tragarze,*vocative.pl=tragarze
tragedia|*genitive.sg=tragedii,*dative.sg=tragedii,*locative.sg=tragedii
traktor|ga
tramwaj|pów
trance|cm,*genitive.sg=trance'u,*dative.sg=trance'owi,*instrumental.sg=trance'em,*locative.sg=transie,*vocative.sg=transie
transformator|ga
transseksualista|pów,P,*nominative.pl=transseksualiści,*accusative.pl=transseksualistów,*vocative.pl=transseksualiści
tranzystor|ga
trasownik|ga
tratwa|p
traumatolog|ga,A,P
trawnik|ga
trefl|ga
trener|ga,A,P
treść|ck,ni,P
trębacz|ga,A,P,*nominative.pl=trębacze,*vocative.pl=trębacze
trędowaty|cn,A,P,*nominative.pl=trędowaci,*genitive.sg=trędowatego,*genitive.pl=trędowatych,*dative.sg=trędowatemu,*dative.pl=trędowatym,*accusative.sg=trędowatego,*accusative.pl=trędowatych,*instrumental.sg=trędowatym,*instrumental.pl=trędowatymi,*locative.sg=trędowatym,*locative.pl=trędowatych,*vocative.pl=trędowaci
troska|p
trójkąt|strójkąt,ga
trucizna|p
trudność|ck,ni,P
trumna|*genitive.pl=trumien
trup|ga,A
truteń|strutni,ga,pi,A
tryk|ga,A
tryktrak|ga,A
trzmiel|ga,A
trzoda|*genitive.pl=trzód
trzonowiec|ga,pów
trzymanie|*genitive.pl=trzymań
tukan|ga,A
tuleja|*genitive.sg=tulei,*genitive.pl=tulei,*dative.sg=tulei,*locative.sg=tulei
tulipan|ga,A
tulipanowiec|ga,pów
tułacz|ga,A,P,*nominative.pl=tułacze,*vocative.pl=tułacze
tułów|stułowi,ga,pi
tuńczyk|ga,A
tur|ga,A
turas|ga,A,P,*nominative.pl=turasy,*vocative.pl=turasy
turniej|pów
turysta|pów,P,*nominative.pl=turyści,*accusative.pl=turystów,*vocative.pl=turyści
turzyca|p
tusz|pów
tuzin|ga
twarz|ck
twierdza|p
twierdzenie|*genitive.pl=twierdzeń
twórca|ny,pów,P,*accusative.pl=twórców
tydzień|stygodni,ga,pi
tygrys|ga,A
tygrysica|p
tyłek|ga
tyranozaur|ga,A
ubek|subek,ga,A,P
ubezpieczenie|*genitive.pl=ubezpieczeń
ubranie|*genitive.pl=ubrań
uchodźca|ny,pów,P,*accusative.pl=uchodźców
uciekinier|ga,A,P
uczennica|p
uczeń|suczni,ga,nowie,pów,A,P
uczucie|*genitive.pl=uczuć
uczulenie|*genitive.pl=uczuleń
uderzenie|*genitive.pl=uderzeń
udój|pów
ukośnik|ga
ukrainiec|sUkraińc,ga,ny,pów,A,P,*vocative.sg=Ukraińcze
ul|ga
ulica|p
ułamek|ga
umiejętność|ck,ni,P
umowa|*genitive.pl=umów
unia|*genitive.sg=unii,*genitive.pl=unii,*dative.sg=unii,*locative.sg=unii
unieważnienie|*genitive.pl=unieważnień
uosobienie|*genitive.pl=uosobień
upiór|ga,A,P,*nominative.pl=upiory,*vocative.pl=upiory
upokorzenie|*genitive.pl=upokorzeń
uprowadzenie|*genitive.pl=uprowadzeń
uprząż|ck
uprzedzenie|*genitive.pl=uprzedzeń
urdzik|ga
urna|p
urodzenie|*genitive.pl=urodzeń
urolog|ga,A,P
urządzenie|*genitive.pl=urządzeń
urzędas|ga,A,P,*nominative.pl=urzędasy,*vocative.pl=urzędasy
urzędnik|ga,A,P
ustępstwo|lu,p
ustnik|ga
uśmiech|ny,*instrumental.sg=uśmiechem
uśmieszek|ga
uwodziciel|ga,A,P,*nominative.pl=uwodziciele,*vocative.pl=uwodziciele
uzależnienie|*genitive.pl=uzależnień
uzasadnienie|*genitive.pl=uzasadnień
uzbek|sUzbek,ga,A,P
uziemienie|*genitive.pl=uziemień
użyszkodnik|ga,A,P
użytkownik|ga,A,P
wabik|ga
wacha|*genitive.sg=wachy
wachlarz|ga
waćpan|ga,lu,nowie,A,P,*vocative.sg=waćpanie
wafel|swafl,ga
wahanie|*genitive.pl=wahań
wajcha|ny,*genitive.sg=wajchy
waldek|ga,nowie,A,P
walec|ga,pów
walet|ga,A
walijczyk|ga,A,P
walka|p
wałach|ga,ny,A,*instrumental.sg=wałachem
wampir|ga,A
wandal|ga,nowie,pów,A,P
wanilia|*genitive.sg=wanilii,*dative.sg=wanilii,*locative.sg=wanilii
wanna|*genitive.pl=wanien
wapień|ga
wapno|p
wapń|ga
waran|ga,A
warcaby|cn,*genitive.sg=warcabów,*dative.sg=warcabom,*instrumental.sg=warcabami,*locative.sg=warcabach
wariat|ga,A,P,*nominative.pl=wariaci,*vocative.pl=wariaci
warkocz|ga
warstwa|p
warszawiak|ga,A,P
warszawianin|ga,A,P
wartość|ck,ni,P
warzucha|ny,*genitive.sg=warzuchy
wasal|ga,A,P,*nominative.pl=wasale,*vocative.pl=wasale
waszmość|ck,ni,P
waść|ck,ni,P
wat|ga
ważniak|ga,A,P
wągier|swągr,ga
wąs|swąs,ga
wątek|swątk
wątpliwość|ck,ni,P
wątroba|*genitive.pl=wątrób
wąż|ga,A
wczasy|cn,*genitive.sg=wczasów,*dative.sg=wczasom,*instrumental.sg=wczasami,*locative.sg=wczasach
wdech|ny,*instrumental.sg=wdechem
wdowa|*genitive.pl=wdów
wdzięczność|ck
weber|ga
weganin|ga,A,P
wegetarianin|ga,A,P
wejście|*genitive.pl=wejść
wektor|ga
wentylator|ga
werbel|swerbl,ga
wesz|ck,swsz,ny,P
weterynarz|ga,A,P,*nominative.pl=weterynarze,*vocative.pl=weterynarze
wezyr|ga,nowie,A,P
węch|*instrumental.sg=węchem
wędkarz|ga,A,P,*nominative.pl=wędkarze,*vocative.pl=wędkarze
wędrowiec|ga,ny,pów,A,P,*vocative.sg=wędrowcze
węgiel|*genitive.sg=węgla,*dative.sg=węglowi,*instrumental.sg=węglem,*locative.sg=węglu,*vocative.sg=węglu
węgieł|swęgł,ga
węgier|sWęgr,ga,A,P
węgorz|ga,A
węgrzyn|ga,ni,A,P
węzeł|swęzł,ga
wiadomości|gi,A,*dative.sg=wiadomościom,*instrumental.sg=wiadomościami,*locative.sg=wiadomościach,*vocative.sg=wiadomości
wiadomość|ck,ni,P
wiadro|*genitive.pl=wiader
wianek|ga
wiara|*dative.sg=wierze,*locative.sg=wierze
wiarygodność|ck
wiaterek|ga
wiatr|*locative.sg=wietrze,*vocative.sg=wietrze
wiatrak|ga
wiąz|swiąz
wibrator|ga
wicher|swichr
widelczyk|ga
widelec|ga,pów
widły|cn,*genitive.sg=wideł,*dative.sg=widłom,*instrumental.sg=widłami,*locative.sg=widłach
widzenie|*genitive.pl=widzeń
wiec|swiec,pów
wiecheć|swiechci,ga,pi
wielbłąd|swielbłąd,ga,A
wielkość|ck,ni,P
wielokąt|swielokąt
wielokropek|ga
wieloryb|ga,A
wieniec|swieńc,ga,pów
wieprz|ga,A
wierność|ck,ni,P
wiersz|ga
wiersza|p
wierzący|cn,ny,A,P,*genitive.sg=wierzącego,*genitive.pl=wierzących,*dative.sg=wierzącemu,*dative.pl=wierzącym,*accusative.sg=wierzącego,*accusative.pl=wierzących,*instrumental.sg=wierzącym,*instrumental.pl=wierzącymi,*locative.sg=wierzącym,*locative.pl=wierzących
wierzbownica|p
wierzch|*instrumental.sg=wierzchem
wierzchowiec|ga,pów,A
wierzyciel|ga,A,P,*nominative.pl=wierzyciele,*vocative.pl=wierzyciele
wiesiołek|ga
wieszczyk|ga,A
wieś|swsi,gi,di,li,pi,*instrumental.sg=wsią
wieśniak|ga,A,P
wietnamczyk|ga,A,P
wietnamiec|ga,ny,pów,A,P,*vocative.sg=wietnamcze
wieżowiec|ga,pów
więcierz|ga
większość|ck,ni,P
więzienie|*genitive.pl=więzień
więzień|swięźni,ga,nowie,pów,A,P
wihajster|swihajstr,ga
wikipedysta|pów,P,*nominative.pl=wikipedyści,*accusative.pl=wikipedystów,*vocative.pl=wikipedyści
wiktoria|*genitive.sg=wiktorii,*dative.sg=wiktorii,*locative.sg=wiktorii
wilczyca|p
wilgotność|ck
wilk|ga,A
wilkołak|ga,A
wiła|*dative.sg=wiłie,*locative.sg=wiłie
winnica|p
winorośl|ck
wiocha|ny,*genitive.sg=wiochy
wiolonczela|p
wirnik|ga
wirus|ga,A
witraż|ga
wjazd|*locative.sg=wjeździe,*vocative.sg=wjeździe
władca|ny,pów,P,*accusative.pl=władców
władza|p
włamanie|*genitive.pl=włamań
własność|ck,ni,P
właściciel|ga,A,P,*nominative.pl=właściciele,*vocative.pl=właściciele
właściwość|ck,ni,P
włoch|ga,A,P,*nominative.pl=Włosi,*instrumental.sg=Włochem,*vocative.pl=Włosi
włodarz|ga,A,P,*nominative.pl=włodarze,*vocative.pl=włodarze
włos|ga
włosienica|p
włość|ck,ni,P
wnętrzności|gi,A,*dative.sg=wnętrznościom,*instrumental.sg=wnętrznościami,*locative.sg=wnętrznościach,*vocative.sg=wnętrzności
wnuczek|ga,nowie,A,P
wnuczę|swnuczęt,*genitive.sg=wnuczęcia,*genitive.pl=wnucząt,*dative.sg=wnuczęciu,*instrumental.sg=wnuczęciem,*locative.sg=wnuczęciu
wnuk|ga,nowie,A,P
wnyki|cn,*genitive.sg=wnyków,*dative.sg=wnykom,*instrumental.sg=wnykami,*locative.sg=wnykach
wodociąg|swodociąg
wodze|*genitive.sg=wodzy,*dative.sg=wodzom,*instrumental.sg=wodzami,*locative.sg=wodzach
wojak|ga,A,P
wojewoda|nowie,pów,P,*accusative.pl=wojewodów
województwo|p
wojsko|p,*instrumental.sg=wojskem
wokalista|pów,P,*nominative.pl=wokaliści,*accusative.pl=wokalistów,*vocative.pl=wokaliści
wola|p
wolt|ga
wołacz|ga,*dative.pl=wołaczami
wombat|ga,A
woń|ck
worek|ga
woskownica|p
woźna|ne,*genitive.sg=woźnej,*genitive.pl=woźnych,*dative.sg=woźnej,*dative.pl=woźnym,*accusative.sg=woźną,*instrumental.pl=woźnymi,*locative.sg=woźnej,*locative.pl=woźnych,*vocative.sg=woźna
woźny|cn,ni,A,P,*genitive.sg=woźnego,*genitive.pl=woźnych,*dative.sg=woźnemu,*dative.pl=woźnym,*accusative.sg=woźnego,*accusative.pl=woźnych,*instrumental.sg=woźnym,*instrumental.pl=woźnymi,*locative.sg=woźnym,*locative.pl=woźnych
wódz|ga,nowie,pów,A,P
wół|A,*genitive.sg=wołu,*accusative.sg=wołu
wór|ga
wózek|swózk,ga
wpierdol|*dative.sg=wpierdolem,*accusative.sg=wpierdolowi
wrażenie|*genitive.pl=wrażeń
wrończyk|ga,A
wrota|cn,*genitive.sg=wrót,*dative.sg=wrotom,*instrumental.sg=wrotami,*locative.sg=wrotach
wrotycz|ga
wróbel|swróbl,ga,A
wróg|ga,nowie,A,P
wrzątek|*genitive.sg=wrzątku,*dative.sg=wrzątkowi,*instrumental.sg=wrzątkiem,*locative.sg=wrzątku,*vocative.sg=wrzątku
wrzesień|swrześni,ga,pi
wspomnienie|*genitive.pl=wspomnień
współczynnik|ga
współpracownik|ga,A,P
wstrząs|swstrząs
wstrzemięźliwość|ck
wszechmoc|ck
wszechświat|ga,*locative.sg=wszechświecie,*vocative.sg=wszechświecie
wuj|ga,nowie,pów,A,P
wujek|ga,nowie,A,P
wybielacz|ga
wyborca|ny,pów,P,*accusative.pl=wyborców
wybraniec|swybrańc,ga,ny,pów,A,P
wybrzeże|py
wybuch|ny,*instrumental.sg=wybuchem
wychodne|*genitive.sg=wychodnego,*dative.sg=wychodnemu,*instrumental.sg=wychodnym,*locative.sg=wychodnym
wycieczkowiec|ga,pów
wydanie|*genitive.pl=wydań
wydarzenie|*genitive.pl=wydarzeń
wydech|ny,*instrumental.sg=wydechem
wygłup|ga,A,*nominative.sg=wygłupy
wygnaniec|swygnańc,ga,ny,pów,A,P
wyjątek|swyjątk
wyjec|ga,pów,A
wyjście|*genitive.pl=wyjść
wykładnik|ga
wykopalisko|p,*instrumental.sg=wykopaliskem
wykrzyknik|ga
wylogowanie|*genitive.pl=wylogowań
wyłącznik|ga
wymię|swymion,*genitive.sg=wymienia,*dative.sg=wymieniu,*instrumental.sg=wymieniem,*locative.sg=wymieniu
wymiociny|cn,*genitive.sg=wymiocin,*dative.sg=wymiocinom,*instrumental.sg=wymiocinami,*locative.sg=wymiocinach
wymuszenie|*genitive.pl=wymuszeń
wynalazca|cm,swynalazc,gy,dy,ly,A,*nominative.sg=wynalazcy,*nominative.pl=wynalazcwynalazców,*accusative.pl=wynalazcwynalazców,*instrumental.sg=wynalazcą,*vocative.pl=wynalazcwynalazców
wypociny|cn,*genitive.sg=wypocin,*dative.sg=wypocinom,*instrumental.sg=wypocinami,*locative.sg=wypocinach
wyporność|ck
wypowiedzenie|*genitive.pl=wypowiedzeń
wyprowadzenie|*genitive.pl=wyprowadzeń
wyprzedaż|ck
wyrażenie|*genitive.pl=wyrażeń
wyróżnik|ga
wyrzutek|ga,A,P,*nominative.pl=wyrzutki,*vocative.pl=wyrzutki
wysokość|ck,ni,P
wyspiarz|ga,A,P,*nominative.pl=wyspiarze,*vocative.pl=wyspiarze
wytrzymałość|ck,*vocative.sg=wytrzymałość
wyznacznik|ga
wyznanie|*genitive.pl=wyznań
wyznawca|ny,pów,P,*accusative.pl=wyznawców
wyzwanie|*genitive.pl=wyzwań
wyżeł|swyżł,ga,A
xbox|ga,*locative.sg=Xboksie,*vocative.sg=Xboksie
zachowanie|*genitive.pl=zachowań
zaćmienie|*genitive.pl=zaćmień
zadanie|*genitive.pl=zadań
zadośćuczynienie|*genitive.pl=zadośćuczynień
zaganiacz|ga,A
zagroda|*genitive.pl=zagród
zagrożenie|*genitive.pl=zagrożeń
zaimek|ga
zainteresowanie|*genitive.pl=zainteresowań
zajazd|*locative.sg=zajeździe,*vocative.sg=zajeździe
zając|szając,ga,A,*genitive.pl=zajęcy
zajączek|szajączk,ga,A
zajęcie|*genitive.pl=zajęć
zajęczak|ga,A
zakażenie|*genitive.pl=zakażeń
zaklęcie|*genitive.pl=zaklęć
zakładnik|ga,A,P
zakonnica|p
zakonnik|ga,A,P
zakończenie|*genitive.pl=zakończeń
zakreślacz|ga
zakrystia|*genitive.sg=zakrystii,*dative.sg=zakrystii,*locative.sg=zakrystii
zakupy|cn,*genitive.sg=zakupów,*dative.sg=zakupom,*instrumental.sg=zakupami,*locative.sg=zakupach
zalążek|szalążk,ga
zaległość|ck,ni,P
zalogowanie|*genitive.pl=zalogowań
zalotnik|ga,A,P
załącznik|ga
założyciel|ga,A,P,*nominative.pl=założyciele,*vocative.pl=założyciele
zamach|ny,*instrumental.sg=zamachem
zamachowiec|ga,ny,pów,A,P
zamieć|ck,ni,P
zamieszki|cn,*genitive.sg=zamieszek,*dative.sg=zamieszkom,*instrumental.sg=zamieszkami,*locative.sg=zamieszkach
zamówienie|*genitive.pl=zamówień
zaopatrzenie|*dative.sg=zaopatrzeniom,*locative.sg=zaopatrzeniach
zapach|ny,*instrumental.sg=zapachem
zapalenie|*genitive.pl=zapaleń
zapożyczenie|*genitive.pl=zapożyczeń
zapytanie|*genitive.pl=zapytań
zasilacz|ga
zaskroniec|szaskrońc,ga,pów,A
zaświaty|cn,*genitive.sg=zaświatów,*dative.sg=zaświatom,*instrumental.sg=zaświatami,*locative.sg=zaświatach
zawartość|ck,ni,P
zawciąg|szawciąg
zawieranie|*genitive.pl=zawierań
zawilec|ga,pów
zawiść|ck
zawodnik|ga,A,P
zazdrość|ck
ząb|ga
zbawiciel|ga,A,P,*nominative.pl=zbawiciele,*vocative.pl=zbawiciele
zbieg|ga,nowie,A,P
zbieżność|ck
zbiornik|ga
zbir|ga,A,P,*nominative.pl=zbiry,*vocative.pl=zbiry
zboże|*genitive.pl=zbóż
zbójca|ny,pów,P,*accusative.pl=zbójców
zbrojarz|ga,A,P,*nominative.pl=zbrojarze,*vocative.pl=zbrojarze
zdanie|*genitive.pl=zdań
zdarzenie|*genitive.pl=zdarzeń
zdjęcia|cn,*genitive.sg=zdjęć,*dative.sg=zdjęciom,*instrumental.sg=zdjęciami,*locative.sg=zdjęciach
zdjęcie|*genitive.pl=zdjęć
zdradnica|p
zdrajca|ny,pów,P,*accusative.pl=zdrajców
zdrajczyni|cf,szdrajczyni,*genitive.pl=zdrajczyń,*vocative.sg=zdrajczyni
zdrobnienie|*genitive.pl=zdrobnień
zdun|ga,ni,A,P
zegar|ga
zegarek|ga
zegarmistrz|ga,nowie,pów,A,P
zew|szw
zeznanie|*genitive.pl=zeznań
zgliszcze|py
zgorzel|ck
zgred|ga,A
zgromadzenie|*genitive.pl=zgromadzeń
zgrubienie|*genitive.pl=zgrubień
ziele|szioł,*genitive.sg=ziela,*genitive.pl=ziół,*dative.sg=zielu,*instrumental.sg=zielem,*locative.sg=zielu
zieleń|ck
ziemia|*genitive.pl=ziem
ziemianin|ga,A,P
ziemniaczek|ga
ziemniak|ga,A
zięć|ga,nowie,pów,A,P
zimorodek|ga,A
zioło|*genitive.pl=ziół
ziom|ga,A,P,*nominative.pl=ziomy,*vocative.pl=ziomy
ziomal|ga,A,P,*nominative.pl=ziomale,*vocative.pl=ziomale
ziomek|ga,nowie,A,P
zjeb|ga,A
zlewozmywak|ga
zło|lu
złocień|ga
złoczyńca|ny,pów,P,*accusative.pl=złoczyńców
złodziej|ga,A,P,*nominative.pl=złodzieje,*genitive.pl=złodziei,*accusative.pl=złodziei,*vocative.pl=złodzieje
złotnik|ga,A,P
złożenie|*genitive.pl=złożeń
zmarły|cn,A,P,*nominative.pl=zmarli,*genitive.sg=zmarłego,*genitive.pl=zmarłych,*dative.sg=zmarłemu,*dative.pl=zmarłym,*accusative.sg=zmarłego,*accusative.pl=zmarłych,*instrumental.sg=zmarłym,*instrumental.pl=zmarłymi,*locative.sg=zmarłym,*locative.pl=zmarłych,*vocative.pl=zmarli
zmartwienie|*genitive.pl=zmartwień
zmartwychwstanie|*genitive.pl=zmartwychwstań
zmienna|ne,*genitive.sg=zmiennej,*genitive.pl=zmiennych,*dative.sg=zmiennej,*dative.pl=zmiennym,*accusative.sg=zmienną,*instrumental.pl=zmiennymi,*locative.sg=zmiennej,*locative.pl=zmiennych,*vocative.sg=zmienna
zmierzch|ny,*instrumental.sg=zmierzchem
znaczenie|*genitive.pl=znaczeń
znajoma|ne,*genitive.sg=znajomej,*genitive.pl=znajomych,*dative.sg=znajomej,*dative.pl=znajomym,*accusative.sg=znajomą,*instrumental.pl=znajomymi,*locative.sg=znajomej,*locative.pl=znajomych,*vocative.sg=znajoma
znajomość|ck,ni,P
znamię|sznamion,*genitive.sg=znamienia,*dative.sg=znamieniu,*instrumental.sg=znamieniem,*locative.sg=znamieniu
znieczulenie|*genitive.pl=znieczuleń
zniszczenie|*genitive.pl=zniszczeń
zoogeografia|*genitive.sg=zoogeografii,*dative.sg=zoogeografii,*locative.sg=zoogeografii
zoolog|ga,A,P
zoologia|*genitive.sg=zoologii,*dative.sg=zoologii,*locative.sg=zoologii
zoopatologia|*genitive.sg=zoopatologii,*dative.sg=zoopatologii,*locative.sg=zoopatologii
zorza|*genitive.pl=zórz
zszywacz|ga
zuchwalstwo|p
zwarcie|*genitive.pl=zwarć
związek|szwiązk
związkowiec|ga,ny,pów,A,P,*vocative.sg=związkowcze
zwierz|ga,A
zwierzę|szwierzęt,*genitive.sg=zwierzęcia,*genitive.pl=zwierząt,*dative.sg=zwierzęciu,*instrumental.sg=zwierzęciem,*locative.sg=zwierzęciu
zwojnica|p
zwój|pów
zwrotnica|p
zwrotnik|ga
zwycięzca|ny,pów,P,*accusative.pl=zwycięzców
zwyczaj|pów
zybuczkowiec|ga,pów,A
źrebię|sźrebięt,*genitive.sg=źrebięcia,*genitive.pl=źrebiąt,*dative.sg=źrebięciu,*instrumental.sg=źrebięciem,*locative.sg=źrebięciu
źrenica|p
żabojad|ga,A,P,*nominative.pl=żabojady,*vocative.pl=żabojady
żagiel|sżagl,ga
żaglowiec|ga,pów
żal|pów
żałoba|*genitive.pl=żałób
żarłok|ga,A,P
żądanie|*genitive.pl=żądań
żądza|p
żbik|ga,A
żebrak|ga,A,P
żebro|*genitive.pl=żeber
żeglarstwo|*vocative.sg=żeglarstwie
żeglarz|ga,A,P,*nominative.pl=żeglarze,*vocative.pl=żeglarze
żeniec|sżeńc,ga,ny,pów,A,P,*vocative.sg=żeńcze
żeń-szeń|ga
żerdź|ck
żłobek|ga
żłób|ga
żłóbek|sżłóbk,ga
żmija|p,*genitive.sg=żmii,*dative.sg=żmii,*locative.sg=żmii
żniwiarz|ga,A,P,*nominative.pl=żniwiarze,*vocative.pl=żniwiarze
żołądek|sżołądk,ga
żołna|p
żołnierz|ga,A,P,*nominative.pl=żołnierze,*vocative.pl=żołnierze
żonkil|ga,A
żółtek|sżółtk,ga,A,P,*nominative.pl=żółtki,*vocative.pl=żółtki
żółw|sżółwi,ga,pi,A
żółwik|ga,A
żubr|ga,A
żubroń|ga,A
żuchwa|p
żuk|ga,A
żul|ga,A,P,*nominative.pl=żule,*vocative.pl=żule
żużel|sżużl,ga
żwacz|ga
życie|*genitive.pl=żyć
życzenie|*genitive.pl=życzeń
żyd|ga,A,P,*nominative.pl=żydzi,*vocative.pl=żydzi
żyd|ga,A,P,*nominative.pl=Żydzi,*vocative.pl=Żydzi
żydek|ga,A,P,*nominative.pl=żydki,*vocative.pl=żydki
żyrandol|ga
żywica|p
żywiec|ga,pów
`;

const CLASSES: Record<string, PlClass> = {
  m: "masculine",
  f: "feminine-a",
  n: "neuter",
  k: "feminine-consonant",
};

function parse(spec: string): PlStemFlags {
  const flags: PlStemFlags = {};
  const forms: Record<string, string> = {};
  for (const part of spec.split(",")) {
    if (part.startsWith("*")) {
      const [cell, form] = part.slice(1).split("=") as [string, string];
      forms[cell] = form;
      continue;
    }
    const code = part[0] as string;
    const value = part.slice(1);
    if (code === "A") flags.animate = true;
    else if (code === "P") flags.personal = true;
    else if (code === "c") {
      const plClass = CLASSES[value];
      if (plClass !== undefined) flags.class = plClass;
    }
    else if (code === "s") flags.stem = value;
    else if (code === "g") flags.genSg = value;
    else if (code === "d") flags.datSg = value;
    else if (code === "l") flags.locSg = value;
    else if (code === "n") flags.nomPl = value;
    else if (code === "p") flags.genPl = value;
  }
  if (Object.keys(forms).length > 0) flags.forms = forms;
  return flags;
}

/** What each noun's paradigm does that the rules do not predict. */
export const STEM_FLAGS: ReadonlyMap<string, PlStemFlags> = new Map(
  STEM_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, spec] = line.split("|") as [string, string];
      return [lemma, parse(spec)] as const;
    }),
);
